<template>
  <div
    class="d-flex flex-ac head"
    :class="{ 'head--account-only': accountOnly }"
  >
    <div v-if="!accountOnly" class="d-flex flex-ac">
      <img
        class="headlogo is-clickable"
        :src="logoSrc"
        :alt="$t('header.logoAlt')"
        :style="{
          marginTop: isShenglianyunLogo ? '0.85714rem' : '0',
          width: isShenglianyunLogo ? '7.14286rem' : '10rem',
        }"
        @click="handleLogoClick"
      />

      <el-menu
        ref="navMenu"
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        active-text-color="#6F42FF"
        background-color="#0D0E12"
        text-color="#ffffff"
        menu-trigger="click"
        @select="handleSelect"
        @open="handleMenuOpen"
        @close="handleMenuClose"
        router
      >
        <el-menu-item class="tablabel" index="/home">
          <i class="el-icon-house nav-menu-icon"></i>
          <span>{{ $t("header.nav.home") }}</span>
        </el-menu-item>
        <!-- <el-menu-item class="tablabel" index="/">
          <img
            v-if="activeIndex != '/'"
            src="../assets/img/tabIcon.png"
            alt=""
          />
          <img
            v-if="activeIndex == '/'"
            src="../assets/img/tabIcon_activate.png"
            alt=""
          />
          <span>抖音Data</span>
        </el-menu-item> -->
        <el-menu-item class="tablabel" index="/myProject">
          <img
            v-show="activeIndex != '/myProject'"
            src="../assets/img/tabIcon.png"
            alt=""
          />
          <img
            v-show="activeIndex == '/myProject'"
            src="../assets/img/tabIcon_activate.png"
            alt=""
          />
          <span>{{ $t("header.nav.workflow") }}</span>
        </el-menu-item>
        <el-menu-item class="tablabel" index="/visionCanvas">
          <img
            v-show="activeIndex != '/visionCanvas'"
            src="../assets/img/tabIcon.png"
            alt=""
          />
          <img
            v-show="activeIndex == '/visionCanvas'"
            src="../assets/img/tabIcon_activate.png"
            alt=""
          />
          <span>{{ $t("header.nav.canvas") }}</span>
        </el-menu-item>
        <el-menu-item class="tablabel" index="/copywritingCreation">
          <img
            v-show="activeIndex != '/copywritingCreation'"
            src="../assets/img/juben.png"
            alt=""
          />
          <img
            v-show="activeIndex == '/copywritingCreation'"
            src="../assets/img/juben_activate.png"
            alt=""
          />
          <span>{{ $t("header.nav.scriptCreation") }}</span>
        </el-menu-item>
        <!-- <el-submenu index="3">
          <span class="tablabel" slot="title">
            <img
              v-if="assetRouteList.indexOf(activeIndex) > -1"
              src="../assets/img/tabIcon_activate.png"
              alt=""
            />
            <img v-else src="../assets/img/tabIcon.png" alt="" />
            <span>我的资产</span>
          </span>
          <el-menu-item class="text-center" index="/roleManagement"
            >角色管理</el-menu-item
          >
          <el-menu-item class="text-center" index="/sceneManagement"
            >场景管理</el-menu-item
          >
          <el-menu-item class="text-center" index="/propManagement"
            >道具管理</el-menu-item
          >
        </el-submenu> -->
        <!-- <el-menu-item
          class="tablabel"
          index="/hotRanking"
          :route="{ path: $route.path }"
        >
          <img
            v-show="activeIndex != '/hotRanking'"
            src="../assets/img/shuju.png"
            alt=""
          />
          <img
            v-show="activeIndex == '/hotRanking'"
            src="../assets/img/shuju_activate.png"
            alt=""
          />
          <span>{{ $t("header.nav.dataInsights") }}</span>
        </el-menu-item> -->
        <el-menu-item class="tablabel" index="/statisticalDimension">
          <img
            v-show="activeIndex != '/statisticalDimension'"
            src="../assets/img/jixiao.png"
            alt=""
          />
          <img
            v-show="activeIndex == '/statisticalDimension'"
            src="../assets/img/jixiao_activate.png"
            alt=""
          />
          <span>{{ $t("header.nav.efficiencyAnalysis") }}</span>
        </el-menu-item>
        <el-submenu ref="helpMenu" class="help-menu" index="help">
          <span class="tablabel" slot="title">
            <img src="../assets/img/use.png" alt="" />
            <span>{{ $t("header.nav.help") }}</span>
            <span
              v-if="messageUnreadCount > 0 && !helpMenuOpen"
              class="header-unread-badge"
              role="status"
              :aria-label="$t('header.accountMenu.feedback')"
            >
              {{ messageUnreadCount > 99 ? "99+" : messageUnreadCount }}
            </span>
          </span>
          <el-menu-item
            class="text-center"
            index="/operationGuide"
            :route="{ path: $route.path }"
          >
            {{ $t("header.nav.guide") }}
          </el-menu-item>
          <el-menu-item
            class="text-center"
            index="/productUpdates"
            :route="{ path: $route.path }"
          >
            {{ $t("header.nav.productUpdates") }}
          </el-menu-item>
          <el-menu-item
            class="text-center"
            index="/feedback"
            :route="{ path: $route.path }"
          >
            <span>{{ $t("header.accountMenu.feedback") }}</span>
            <span
              v-if="messageUnreadCount > 0"
              class="header-unread-badge"
              role="status"
              :aria-label="$t('header.accountMenu.feedback')"
            >
              {{ messageUnreadCount > 99 ? "99+" : messageUnreadCount }}
            </span>
          </el-menu-item>
        </el-submenu>
      </el-menu>
      <!-- <span
        class="tablabel d-flex flex-ac"
        v-for="(item, index) of tabData"
        :key="index"
        @click="jump(item)"
        :class="selectTab == item.id ? 'activate' : ''"
      >
        <img
          v-if="selectTab != item.id"
          src="../assets/img/tabIcon.png"
          alt=""
        />
        <img
          v-if="selectTab == item.id"
          src="../assets/img/tabIcon_activate.png"
          alt=""
        />
        <span>{{ item.name }}</span>
      </span> -->
    </div>
    <div class="d-flex flex-ac pointsInformation">
      <div
        v-if="!accountOnly && $i18n.locale !== 'zh-CN'"
        class="header-language-switch"
        role="group"
        :aria-label="$t('header.language.label')"
      >
        <button
          type="button"
          :class="{ active: $i18n.locale === 'en-US' }"
          :aria-pressed="$i18n.locale === 'en-US'"
          @click="changeLocale('en-US')"
        >
          {{ $t("header.language.shortEnUS") }}
        </button>
        <button
          type="button"
          :class="{ active: $i18n.locale === 'yue' }"
          :aria-pressed="$i18n.locale === 'yue'"
          @click="changeLocale('yue')"
        >
          {{ $t("header.language.shortYueHK") }}
        </button>
      </div>
      <button
        v-if="
          subscriptionTriggerLabel &&
          !this.$store.state.isCloseVip &&
          canShowMembershipPurchase
        "
        class="subscription-trigger"
        type="button"
        :aria-label="subscriptionTriggerLabel"
        @click="openSubscriptionDialog"
      >
        {{ subscriptionTriggerLabel }}
      </button>
      <PointsPopover
        v-if="!useLegacyPointsPopover"
        @membership="openSubscriptionDialog"
        @recharge="headerBtnClick"
        @view-usage="openUsagePanel"
        @points-updated="handlePointsUpdated"
      />
      <el-popover
        v-if="useLegacyPointsPopover"
        placement="bottom"
        width="250"
        trigger="hover"
        popper-class="user-card-popover"
      >
        <div class="score-card">
          <div class="title">积分</div>

          <div class="rowTitle main-score" style="">
            <img
              class="icon"
              src="../assets/img/integralSynthesis.png"
              alt=""
            />
            <span class="label">积分</span>
            <span class="value blue">{{ allTotal }}</span>
          </div>
          <div class="rowTitle">
            <span style="margin-right: 0.42857rem; width: 1rem; height: 1.21429rem"></span>
            <span class="label">免费积分</span>
            <span class="value">{{ topUpIntegral }}</span>
          </div>
          <div class="btn-box">
            <button class="charge-btn" @click="headerBtnClick">充值</button>
          </div>
          <div @click="openUsagePanel" class="link">
            查看使用情况 <span class="arrow">></span>
          </div>
        </div>
        <div class="points" slot="reference">
          <span>{{ "积分：" + allTotal }} </span>
          <span>|</span>
          <span @click="headerBtnClick" class="pointer">充值</span>
        </div>
      </el-popover>
      <TaskCenter v-if="!accountOnly" :running-count="aiTaskRunningCount" />
      <el-popover
        placement="bottom"
        width="300"
        trigger="manual"
        v-model="userPopoverVisible"
        popper-class="user-menu-popover"
        effect="effect"
      >
        <div
          class="user-menu-panel"
          @mouseenter="openUserPopover"
          @mouseleave="scheduleCloseUserPopover"
        >
          <section class="user-menu-panel__summary">
            <span class="user-menu-panel__label">
              {{ $t("header.accountMenu.currentAccount") }}
            </span>
            <span class="user-menu-panel__username line-1">{{
              user.username
            }}</span>
          </section>

          <div
            class="user-menu-panel__divider user-menu-panel__divider--footer-top"
          ></div>

          <section class="user-menu-panel__footer">
            <template v-for="(item, index) in showMenuItems">
              <el-popover
                v-if="item.text === '备案信息'"
                :key="`beian-${item.id}`"
                placement="left-start"
                trigger="manual"
                v-model="beianPopoverVisible"
                popper-class="beian-popover"
                :visible-arrow="false"
              >
                <div
                  class="beian-panel"
                  @mouseenter="openBeianPopover"
                  @mouseleave="scheduleCloseBeianPopover"
                >
                  <a
                    class="beian-panel-link"
                    :href="getAgreementUrl('terms')"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>用户协议</span>
                    <i class="el-icon-top-right"></i>
                  </a>
                  <a
                    class="beian-panel-link"
                    :href="getAgreementUrl('privacy')"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span>隐私政策</span>
                    <i class="el-icon-top-right"></i>
                  </a>
                  <div class="beian-panel-divider"></div>
                </div>
                <button
                  slot="reference"
                  type="button"
                  class="user-menu-panel__action"
                  @mouseenter="openBeianPopover"
                  @mouseleave="scheduleCloseBeianPopover"
                >
                  <span class="user-menu-panel__action-left">
                    <i :class="item.icon"></i>
                    <span>{{ $t(item.i18nKey) }}</span>
                  </span>
                  <i class="el-icon-arrow-right user-menu-panel__arrow"></i>
                </button>
              </el-popover>
              <button
                v-else
                :key="`menu-${item.id}`"
                type="button"
                class="user-menu-panel__action"
                @click="openInformation(item.text)"
              >
                <span class="user-menu-panel__action-left">
                  <i :class="item.icon"></i>
                  <span>{{ $t(item.i18nKey) }}</span>
                </span>
                <i class="el-icon-arrow-right user-menu-panel__arrow"></i>
              </button>
              <div
                v-if="index < showMenuItems.length - 1"
                :key="`divider-${item.id}`"
                class="user-menu-panel__divider"
              ></div>
            </template>

            <div
              class="user-menu-panel__divider user-menu-panel__divider--logout-top"
            ></div>

            <button
              type="button"
              class="user-menu-panel__action user-menu-panel__action--logout"
              @click="logout"
            >
              <span class="user-menu-panel__action-left">
                <i class="el-icon-switch-button"></i>
                <span>{{ $t("header.accountMenu.logout") }}</span>
              </span>
            </button>
          </section>
        </div>
        <!-- <img
          class="ProfilePicture pointer"
          src="../assets/img/avatar.png"
          alt=""
        /> -->
        <div
          slot="reference"
          class="avatar"
          @mouseenter="openUserPopover"
          @mouseleave="scheduleCloseUserPopover"
        >
          <!-- <img class="mr-2" src="../assets/img/avatar.png" alt="" />
          <span>{{ user.username }}</span> -->
          <span class="avatar-text">{{ user.username?.slice(0, 1) }}</span>
        </div>
      </el-popover>
    </div>
    <!-- 联系客服弹窗 -->
    <el-dialog
      destroy-on-close
      :visible.sync="contactDialogVisible"
      width="27.14286rem"
      :close-on-click-modal="true"
      :show-close="false"
      custom-class="contact-service-dialog"
      append-to-body
    >
      <div class="contact-service">
        <div class="contact-service__header">
          <span>{{ $t("header.contactDialog.title") }}</span>
          <button type="button" @click="contactDialogVisible = false">×</button>
        </div>
        <div class="contact-service__body">
          <p class="contact-service__desc">
            {{ $t("header.contactDialog.description") }}
          </p>
          <div class="contact-service__qr">
            <img :src="qyCode" :alt="$t('header.contactDialog.qrCodeAlt')" />
          </div>
          <!-- <div class="contact-service__phone-label">客服电话</div>
          <div class="contact-service__phone">19056348252</div> -->
          <!-- <div class="contact-service__time">工作日 9:00 - 18:00</div> -->
        </div>
      </div>
    </el-dialog>
    <feedback-dialog :visible.sync="feedbackDialogVisible" />
    <!-- 扫码支付弹窗 -->
    <el-dialog
      destroy-on-close
      :close-on-click-modal="false"
      :title="paymentMethod == 1 ? '微信扫码支付' : '支付宝扫码支付'"
      :visible.sync="payPopupWindow"
      width="30rem"
      @close="turnOffQRCode"
      custom-class="qrCodeClass"
      append-to-body
    >
      <div class="pay-weixin text-center">
        <div class="qr-pay-summary" v-if="selectedRechargePackage">
          <div class="qr-pay-summary__item">
            <span>金额</span>
            <strong>{{ getPackageMoney(selectedRechargePackage) }}</strong>
          </div>
          <div class="qr-pay-summary__item">
            <span>积分</span>
            <strong>{{ getPackageIntegral(selectedRechargePackage) }}</strong>
          </div>
        </div>
        <img
          style="
            border: 1px solid rgba(255, 255, 255, 0.1);
            width: 14.28571rem;
            border-radius: 0.57143rem;
          "
          :src="qrCodeImgUrl"
        />
        <div class="mt-3">
          {{
            `请使用手机打开${
              paymentMethod == 1 ? "微信" : "支付宝"
            }扫描二维码完成支付`
          }}
        </div>
        <span class="confirmPayment pointer" @click="completePayment"
          >已完成支付</span
        >
      </div>
    </el-dialog>
    <!-- 支付结果弹窗 -->
    <el-dialog
      destroy-on-close
      :visible.sync="payResultPop"
      width="25%"
      :show-close="false"
      append-to-body
      custom-class="qrCodeClass payResultDialog"
    >
      <div slot="title" class="text-right">
        <img
          class="pointer"
          @click="closeDialog"
          src="../assets/img/close.png"
          alt=""
          width="1.42857rem"
          height="1.42857rem"
        />
      </div>
      <div class="text-center">
        <div class="resultTitle">支付结果</div>
        <img
          v-if="payResultMessage"
          src="../assets/img/paySuccess.png"
          alt=""
          width="100"
          height="100"
        />
        <img
          v-if="!payResultMessage"
          src="../assets/img/paymentFailed.png"
          alt=""
          width="100"
          height="89"
        />
        <div class="subtitle" v-if="payResultMessage">
          <span class="ml-1">支付成功</span>
        </div>
        <div class="subtitle" v-if="!payResultMessage">
          <span>未查询到支付结果</span>
          <span>若您已完成支付，请稍后在充值明细页面中查看账单信息!</span>
        </div>
      </div>
      <div slot="footer" class="dialog-footer text-center">
        <div class="confirmPayment">
          <span class="pointer" @click="closeDialog">
            {{ countdown > 0 ? `确认 (${countdown})` : "确认" }}
          </span>
        </div>
      </div>
    </el-dialog>
    <!-- 账户信息弹窗 -->
    <el-dialog
      destroy-on-close
      :visible.sync="accountPop"
      width="90%"
      top="5vh"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="account-dialog account-usage-dialog"
      append-to-body
      @close="vipCode = ''"
    >
      <div class="dialog-content">
        <!-- 左侧菜单 -->
        <div class="sidebar">
          <div class="logo">
            <span>{{ $t("header.accountCenter.productName") }}</span>
          </div>
          <ul class="menu">
            <li
              v-for="(item, index) in finalMenuItems"
              :key="index"
              class="menu-item"
              :class="{ active: informationPop === item.text }"
              @click="menuSwitching(item)"
            >
              <span>
                <img
                  :src="
                    require(`../assets/img/${item.icon}${
                      informationPop === item.text ? '_active' : ''
                    }.png`)
                  "
                  alt=""
                  :width="item.width"
                  :height="item.height"
                />
              </span>
              <span>{{ $t(item.i18nKey) }}</span>
            </li>
          </ul>
        </div>

        <!-- 右侧内容 -->
        <div class="main-content">
          <div class="acct-header">
            <div class="acct-title">{{ accountSectionTitle }}</div>
            <div class="acct-actions">
              <!-- <el-button class="acct-logout" type="text">退出登录</el-button> -->
              <span
                v-if="informationPop == '账户'"
                @click="logout"
                class="d-flex flex-ac pointer mr-3"
              >
                <img
                  width="20"
                  height="20"
                  src="../assets/img/exitLogin.png"
                  alt=""
                />
                <el-button class="acct-logout" type="text">
                  {{ $t("header.accountMenu.logout") }}
                </el-button>
              </span>
              <div @click="accountPop = false" class="acct-close">✕</div>
            </div>
          </div>
          <!-- 积分卡片 -->
          <div v-if="informationPop == '账户'" class="acct-root">
            <div class="acct-card acct-card--info">
              <div
                class="acct-card__title d-flex flex-ac justify-content-between"
                style="height: 2.85714rem"
              >
                <span>{{ $t("header.accountCenter.accountInfo") }}</span>
              </div>

              <div class="acct-row" v-for="(v, k) in infoRows" :key="k">
                <div class="acct-row__left">{{ $t(v.i18nKey) }}</div>
                <div class="acct-row__right">{{ v.value }}</div>
              </div>
              <!-- <div class="acct-row">
                <div class="acct-row__left">
                  <span style="margin-right: 1.42857rem">会员兑换</span>
                  <el-input
                    size="small"
                    v-model="vipCode"
                    placeholder="请输入兑换码"
                    class="acct-exchange__input"
                    clearable
                  ></el-input>
                </div>
                <div class="acct-row__right">
                  <el-button
                    size="small"
                    class="acct-exchange__btn"
                    @click="exchange"
                    :loading="exchangeLoading"
                  >
                    兑换
                  </el-button>
                </div>
              </div> -->
            </div>

            <div class="acct-card acct-card--points">
              <div class="acct-points__head">
                <div class="acct-card__title">
                  {{ $t("header.accountCenter.points") }}
                </div>
                <!-- <el-button class="acct-charge" plain @click="doSomething"
                  >充值</el-button
                > -->
              </div>

              <div class="acct-points__body">
                <div class="acct-point" v-for="(p, idx) in points" :key="idx">
                  <div class="acct-point__label d-flex flex-ac">
                    <img
                      v-if="p.key === 'total'"
                      src="../assets/img/integralSynthesis.png"
                      alt=""
                    />
                    <span
                      style="width: 0.92857rem; height: 1.14286rem; margin-right: 0.71429rem"
                      v-if="p.key !== 'total'"
                    ></span>
                    <span>{{ $t(p.i18nKey) }}</span>
                  </div>
                  <div class="acct-point__val">
                    {{ formatRechargeNumber(p.value) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 使用情况列表 -->
          <div v-if="informationPop == '使用情况'" class="acct-root">
            <el-table
              :data="tableData"
              class="dark-table"
              style="width: 100%; margin-top: 1.57143rem"
              element-loading-spinner="el-icon-loading"
              v-loading="useLoading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              max-height="580"
            >
              <el-table-column
                prop="user"
                :label="$t('header.accountCenter.serialNumber')"
                align="center"
                width="60"
              >
                <template slot-scope="scope">
                  <span>{{
                    (usePageNum - 1) * usePageSize + scope.$index + 1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                v-for="(item, index) of useHeading"
                :key="index"
                :label="$t(item.i18nKey)"
                align="center"
                :width="item.width"
              >
                <template slot-scope="scope">
                  <span>{{ nonNullCheck(scope.row[item.prop]) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="informationPop == '使用情况'" class="pagingComponent">
            <el-pagination
              v-if="useTotal > 0"
              :current-page="usePageNum"
              @current-change="handleCurrentChange"
              background
              layout="total,prev, pager, next"
              :total="useTotal"
              :page-size="usePageSize"
            >
            </el-pagination>
          </div>
          <!-- 订单管理 -->
          <div v-if="informationPop == '充值记录'" class="acct-root">
            <el-table
              :data="orderListData"
              class="dark-table"
              style="width: 100%; margin-top: 1.57143rem"
              element-loading-spinner="el-icon-loading"
              v-loading="orderLoading"
              element-loading-background="rgba(0, 0, 0, 0.8)"
              max-height="580"
            >
              <el-table-column
                prop="user"
                :label="$t('header.accountCenter.serialNumber')"
                align="center"
                width="60"
              >
                <template slot-scope="scope">
                  <span>{{
                    (orderPageNum - 1) * orderPageSize + scope.$index + 1
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                v-for="(item, index) of orderHeading"
                :key="index"
                :label="$t(item.i18nKey)"
                align="center"
                :width="item.width"
              >
                <template slot-scope="scope">
                  <span>{{ nonNullCheck(scope.row[item.prop]) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div v-if="informationPop == '充值记录'" class="pagingComponent">
            <el-pagination
              v-if="orderTotal > 0"
              :current-page="orderPageNum"
              @current-change="handleOrderCurrentChange"
              background
              layout="total,prev, pager, next"
              :total="orderTotal"
              :page-size="orderPageSize"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      destroy-on-close
      :visible.sync="visible"
      width="100%"
      :fullscreen="true"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="account-dialog recharge-dialog"
      append-to-body
    >
      <div class="wrap recharge-wrap d-flex flex-column">
        <div class="recharge-top">
          <div class="recharge-header">
            <h2 class="recharge-title">充值积分</h2>
            <p class="recharge-subtitle">
              选择套餐或直接输入金额，充值后积分将自动分配到您的账户。
            </p>
            <p class="recharge-subtitle">
              本页单独购买的积分，来自直接充值，永久有效；会员订阅的积分，来自购买订阅套餐每月赠送，到期日清零。系统优先消耗会员订阅积分。
            </p>
          </div>
          <button
            class="acct-close recharge-close"
            type="button"
            @click="visible = false"
          >
            ✕
          </button>
        </div>

        <!-- 会员到期 -->
        <div
          class="expire-box flex-ac"
          v-if="rechargeType != 'points' && vipType == 1"
        >
          <div>
            <div class="expire-title">会员</div>
            <div class="expire-title font_16" style="color: #111827">
              会员到期时间
            </div>
          </div>
          <div class="expire-value">{{ validTime }}</div>
        </div>
        <div
          class="expire-box flex-ac"
          v-if="rechargeType != 'points' && vipType == 0"
        >
          <div>
            <!-- <div class="expire-title"></div> -->
            <div class="expire-title" style="color: #111827; font-size: max(12PX, 1.14286rem)">
              普通用户
            </div>
          </div>
        </div>
        <!-- 卡片 -->
        <div class="cards" v-if="rechargeType == 'vip'">
          <div
            class="topupcard"
            v-for="(item, index) of vipPackages"
            :key="index"
          >
            <div
              class="badge"
              :class="
                item.vipName == '月卡'
                  ? ' b-blue'
                  : item.vipName == '季卡'
                  ? ' b-green'
                  : item.vipName == '年卡'
                  ? ' b-purple'
                  : ' b-red'
              "
            >
              {{ item.vipName }}
            </div>
            <div class="card-title">{{ item.vipName }}</div>
            <div class="d-flex flex-ac">
              <div class="card-price">{{ "¥ " + item.moneyNum }}</div>
              <div class="old-price">{{ "¥ " + item.oldPrice }}</div>
            </div>
            <div class="card-days">{{ "/" + item.dayNum + "天" }}</div>
            <div class="desc">
              {{ item.integralNum + " 积分+" + item.giveNum + " 赠送积分"
              }}<br />
              {{ "共可获得 " + item.integralTotal + " 积分" }}
            </div>
            <div class="btn" @click="confirmRecharge(item, index, 2)">
              {{
                item.vipName != "月卡" &&
                item.vipName != "季卡" &&
                item.vipName != "年卡" &&
                item.vipName != "半年卡"
                  ? "立即体验"
                  : "开通" + item.vipName
              }}
            </div>
          </div>
        </div>
        <div class="recharge-body" v-if="rechargeType == 'points'">
          <div class="cards recharge-cards">
            <div
              class="topupcard recharge-card"
              v-for="(item, index) of packages"
              :key="index"
              :class="{ active: isRechargePackageSelected(index) }"
              @click="selectRechargePackage(item, index)"
            >
              <div
                v-if="isRechargeValuePackage(index)"
                class="recharge-value-badge"
              ></div>
              <div class="card-title point-card-title">
                <div>
                  {{ formatRechargeNumber(getPackageBaseIntegral(item)) }} 积分
                </div>
                <div v-if="getPackageGiveIntegral(item)" class="point-gift">
                  送
                  {{ formatRechargeNumber(getPackageGiveIntegral(item)) }} 积分
                </div>
              </div>
              <div class="point-price-row d-flex flex-ac">
                <div class="currency-price currency-price--card">
                  <span class="currency-symbol">¥</span>
                  <span class="currency-value">{{
                    formatMoneyAmount(item.moneyNum)
                  }}</span>
                </div>
              </div>
              <button
                type="button"
                class="btn recharge-card__button"
                @click.stop="selectRechargePackage(item, index)"
              >
                {{ $t("common.clickSelect") }}
              </button>
            </div>
          </div>

          <div class="custom-amount recharge-custom">
            <div class="custom-amount__title">自定义金额</div>
            <div class="custom-amount__main">
              <label class="custom-amount__input-wrap">
                <input
                  class="custom-amount__input"
                  type="text"
                  inputmode="numeric"
                  maxlength="6"
                  :value="customRechargeAmount || ''"
                  placeholder="请输入金额"
                  @input="handleCustomAmountInput"
                  @focus="selectCustomRechargeMode"
                />
                <span class="custom-amount__unit">元</span>
              </label>
            </div>
            <div class="custom-amount__row">
              <span class="custom-amount__tip">
                充值金额需为整数且不低于 1 元，预计到账
                {{ formatRechargeNumber(customRechargeIntegral) }} 积分
                <template v-if="customRechargeGiveRate > 0">
                  {{
                    $t("header.recharge.bonusRate", {
                      rate: formatRechargeNumber(customRechargeGiveRate),
                    })
                  }}
                </template>
              </span>
            </div>

            <div class="recharge-pay-section">
              <div class="pay-title">支付方式</div>
              <div class="recharge-pay-methods">
                <button
                  type="button"
                  class="pay-list recharge-pay-item"
                  @click="paymentMethod = 2"
                  :class="{ selected: paymentMethod == 2 }"
                >
                  <img
                    width="22"
                    height="22"
                    src="../assets/img/alipay.png"
                    alt=""
                  />
                  <span class="alipay-text">支付宝</span>
                </button>
                <button
                  type="button"
                  class="pay-list recharge-pay-item"
                  @click="paymentMethod = 1"
                  :class="{ selected: paymentMethod == 1 }"
                >
                  <img
                    width="22"
                    height="22"
                    src="../assets/img/wechat.png"
                    alt=""
                  />
                  <span class="wx-text">微信支付</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="recharge-footer" v-if="rechargeType == 'points'">
          <div class="recharge-footer__inner">
            <div class="recharge-footer__summary">
              <span class="recharge-footer__item">
                应付金额
                <strong class="currency-price currency-price--footer">
                  <span class="currency-symbol">¥</span>
                  <span class="currency-value">{{
                    formatMoneyAmount(payableAmountDisplay)
                  }}</span>
                </strong>
              </span>
              <span class="recharge-footer__item">
                获得积分
                <strong>{{ formatRechargeNumber(payablePoints) }}</strong>
              </span>
            </div>
            <button
              type="button"
              class="recharge-footer__pay"
              :disabled="rechargeLoad"
              @click="handlePayNow"
            >
              立即支付
            </button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      destroy-on-close
      :visible.sync="passwordPop"
      width="35.71429rem"
      :close-on-click-modal="false"
      :show-close="false"
      custom-class="password-dialog"
      append-to-body
      @close="disablePassword"
    >
      <div class="resetPart">
        <span>{{ $t("header.passwordDialog.title") }}</span>
        <el-form
          ref="form"
          :model="form"
          class="form mt-3"
          id="form"
          :rules="passwordRules"
          :validate-on-rule-change="false"
        >
          <el-form-item v-if="passwordConfigured === true" prop="password">
            <span class="form-name">
              <span>*</span>
              <span>{{ $t("header.passwordDialog.oldPassword") }}</span>
            </span>
            <el-input
              v-model="form.password"
              show-password
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item prop="newPassword">
            <span class="form-name">
              <span>*</span>
              <span>{{ $t("header.passwordDialog.newPassword") }}</span>
            </span>
            <el-input
              v-model="form.newPassword"
              show-password
              autocomplete="off"
            ></el-input>
            <small class="red" v-show="newPassword">
              *{{ $t("header.passwordDialog.enterNewPassword") }}
            </small>
          </el-form-item>
          <el-form-item prop="confirmNewPassword">
            <span class="form-name">
              <span>*</span>
              <span>{{ $t("header.passwordDialog.confirmNewPassword") }}</span>
            </span>
            <el-input
              v-model="form.confirmNewPassword"
              show-password
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item align="center">
            <el-button size="small" @click="passwordPop = false">
              {{ $t("common.cancel") }}
            </el-button>
            <el-button size="small" type="primary" @click="onSubmit">
              {{ $t("common.save") }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <confirm-dialog
      :visible.sync="show"
      :type="popUpWindowType"
      :sceneType="dataToBeDeleted"
      :value="editInput"
      @confirm="onConfirm"
      @cancel="onCancel"
    />
    <subscription-panel
      :visible.sync="subscriptionVisible"
      @open-add-seats="openAddSeatsFromSubscription"
    />
    <member-center-panel
      :visible.sync="memberCenterVisible"
      :initial-tab="memberCenterTab"
      :auto-open-add-seats="memberCenterAutoOpenAddSeats"
      @open-subscription="openSubscriptionFromMemberCenter"
      @add-seats-opened="onMemberCenterAddSeatsOpened"
    />
    <!-- 更新日志全屏弹窗 -->
    <changelog-dialog :visible.sync="changelogDialogVisible" />
  </div>
</template>

<script>
import bus from "@/bus.js";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import ChangelogDialog from "@/components/ChangelogDialog.vue";
import FeedbackDialog from "@/components/FeedbackDialog.vue";
import PointsPopover from "@/components/PointsPopover.vue";
import TaskCenter from "@/components/TaskCenter.vue";
import SubscriptionPanel from "@/views/subscription/index.vue";
import MemberCenterPanel from "@/views/memberCenter/index.vue";
import qyCode from "@/assets/qy_code.png";
import QRCode from "qrcode";

import { setLocale } from "@/i18n";
import { clearPermissionCache } from "@/utils/permission";
import { canPurchaseMembership, isManager } from "@/utils/accountRole";
import {
  CLIENT_TYPE,
  isSubscriptionButtonHidden,
  persistUserFields,
  syncSubscriptionAccountTypeFromUser,
} from "@/utils/subscription";
import { clearPendingAnnouncement } from "@/utils/announcement";

const MANYU_HELP_MANUAL_URL = "https://manyutop.com/handbook/manyu/";
const DEFAULT_HELP_MANUAL_URL = "https://manyutop.com/handbook/oem/";
// 部署侧可用 VUE_APP_HELP_MANUAL_URL 覆盖操作指南地址（如香港版指向本站 /handbook/）
// VUE_APP_HELP_MANUAL_URL_EN 为英文界面时的地址；未配置则回退到默认覆盖地址
const HELP_MANUAL_URL_OVERRIDE = process.env.VUE_APP_HELP_MANUAL_URL || "";
const HELP_MANUAL_URL_OVERRIDE_EN =
  process.env.VUE_APP_HELP_MANUAL_URL_EN || "";
const CUSTOM_RECHARGE_AMOUNT_MAX_LENGTH = 6;
const CUSTOM_RECHARGE_AMOUNT_PATTERN = /^[1-9]\d{0,5}$/;
const MESSAGE_UNREAD_POLL_INTERVAL = 10 * 1000;
const PENDING_ACTIVITY_KEY = "pendingActivityPromotion";

export default {
  components: {
    ConfirmDialog,
    ChangelogDialog,
    FeedbackDialog,
    PointsPopover,
    TaskCenter,
    SubscriptionPanel,
    MemberCenterPanel,
  },
  props: {
    accountOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(
          new Error(this.$t("header.passwordDialog.enterConfirmPassword")),
        );
      } else if (value !== this.form.newPassword) {
        callback(new Error(this.$t("header.passwordDialog.passwordMismatch")));
      } else {
        callback();
      }
    };
    return {
      validateConfirmPassword: validatePass2,
      activeIndex: "/home",
      tabData: [
        { name: "棣栭〉", id: "home", url: "/home" },
        { name: "热门榜单", id: "hotRanking", url: "/hotRanking" },
        {
          name: "统计维度",
          id: "statisticalDimension",
          url: "/statisticalDimension",
        },
        {
          name: "剧本创作",
          id: "copywritingCreation",
          url: "/copywritingCreation",
        },
        // { name: "抖音Data", id: "homePage", url: "/" },
        { name: "我的项目", id: "myProject", url: "/myProject" },
        { name: "泫宗画布", id: "visionCanvas", url: "/visionCanvas" },
        { name: "角色管理", id: "roleManagement", url: "/roleManagement" },
        { name: "场景管理", id: "sceneManagement", url: "/sceneManagement" },
        { name: "道具管理", id: "propManagement", url: "/propManagement" },
      ],
      assetRouteList: [
        "/roleManagement",
        "/sceneManagement",
        "/propManagement",
      ],
      selectTab: "homePage",
      user: {},
      menuItems: [
        {
          id: 0,
          icon: "el-icon-user",
          text: "个人中心",
          i18nKey: "header.accountMenu.personalCenter",
        },
        {
          id: 4,
          icon: "el-icon-lock",
          text: "修改密码",
          i18nKey: "header.accountMenu.changePassword",
        },
        {
          id: 9,
          icon: "el-icon-s-custom",
          text: "团队管理",
          i18nKey: "header.accountMenu.teamManagement",
        },
        {
          id: 11,
          icon: "el-icon-document",
          text: "开发票",
          i18nKey: "header.accountMenu.invoice",
        },
        {
          id: 6,
          icon: "el-icon-tickets",
          text: "充值记录",
          i18nKey: "header.accountMenu.rechargeRecords",
        },
        {
          id: 7,
          icon: "el-icon-document-checked",
          text: "备案信息",
          i18nKey: "header.accountMenu.filingInfo",
        },
        {
          id: 12,
          icon: "el-icon-edit-outline",
          text: "问题反馈",
          i18nKey: "header.accountMenu.feedback",
        },
        {
          id: 10,
          icon: "el-icon-service",
          text: "联系我们",
          i18nKey: "header.accountMenu.contactUs",
        },
      ],
      freeIntegral: 0,
      topUpIntegral: 0,
      allTotal: 0,
      vipIntegral: 0,
      vipType: 0,
      validTime: 0,
      /** 修改密码 */
      form: {
        username: "",
        password: "",
        newPassword: "",
        confirmNewPassword: "",
      },
      /**
       * 密码输入错误提示
       */
      oldCode: false,
      passError: false,
      newPassword: false,
      confirm: false,
      disagree: false,

      paymentMethod: "2", //1微信支付  2支付宝支付
      payPopupWindow: false, // 支付弹窗
      visible: false,
      qrCodeImgUrl: "", // 二维码图片地址
      outTradeNo: "", // 订单号
      timerId: null, // 定时器ID
      rechargePop: false, // 充值弹窗
      rechargeType: "points", // 充值类型 vip  points
      vipPackages: [], // 会员套餐
      packages: [], // 积分套餐
      customRechargeAmount: "",
      // 自定义金额兑换配置由后端下发，接口异常时沿用原来的 1 元 10 积分且不展示赠送
      customRechargeRate: 10,
      customRechargeGiveRate: 0,
      selectedRechargePackage: null,
      selectedPackageIndex: null,
      rechargeSelectionMode: "",
      rechargeLoad: false,
      payResultPop: false, // 支付结果弹窗
      payResultMessage: false, // 支付结果信息 true成功 false失败
      countdown: 0, // 倒计时秒数
      timer: null, // 倒计时定时器
      accountPop: false, // 账户信息弹窗
      passwordPop: false, //修改密码弹窗
      passwordConfigured: true,
      contactDialogVisible: false,
      feedbackDialogVisible: false,
      // 更新日志全屏弹窗显隐
      changelogDialogVisible: false,
      qyCode,
      informationPop: "", // 账户信息弹窗显示内容
      userPopoverVisible: false,
      beianPopoverVisible: false,
      subscriptionVisible: false,
      memberCenterVisible: false,
      memberCenterTab: "subscription",
      // 套餐弹窗「新增席位」跳转个人中心后自动打开增席弹窗
      memberCenterAutoOpenAddSeats: false,
      useLegacyPointsPopover: false,
      userPopoverTimer: null,
      beianPopoverTimer: null,
      userPopoverHovering: false,
      vipCode: "", // 会员兑换码
      exchangeLoading: false,
      show: false,
      popUpWindowType: "",
      dataToBeDeleted: {},
      editInput: "",
      useLoading: false,
      tableData: [],
      orderListData: [],
      orderLoading: false,
      infoRows: [
        {
          key: "registeredAt",
          i18nKey: "header.accountCenter.registeredAt",
          value: "2025-02-16",
        },
        {
          key: "account",
          i18nKey: "header.accountCenter.account",
          value: "15265895214",
        },
        // { label: "身份", value: "会员" },
        // { label: "会员到期时间", value: "2026-02-16" },
      ],
      points: [
        {
          key: "total",
          i18nKey: "header.accountCenter.totalPoints",
          value: 0,
        },
        // { label: "免费积分", value: 0 },
        // { label: "会员积分", value: 0 },
        // { label: "补充积分", value: 0 },
      ],
      useHeading: [
        {
          i18nKey: "header.accountCenter.columns.details",
          prop: "payDescription",
        },
        {
          i18nKey: "header.accountCenter.columns.time",
          prop: "gmtCreate",
          width: 160,
        },
        {
          i18nKey: "header.accountCenter.columns.pointsChange",
          prop: "integralChange",
          width: 100,
        },
        { i18nKey: "header.accountCenter.columns.model", prop: "model" },
        {
          i18nKey: "header.accountCenter.columns.resolution",
          prop: "resolution",
          width: 80,
        },
        {
          i18nKey: "header.accountCenter.columns.duration",
          prop: "duration",
          width: 80,
        },
      ], //使用情况列表表头
      orderHeading: [
        { i18nKey: "header.accountCenter.columns.orderNo", prop: "orderNo" },
        {
          i18nKey: "header.accountCenter.columns.orderAmount",
          prop: "totalMoney",
          width: 120,
        },
        {
          i18nKey: "header.accountCenter.columns.orderPoints",
          prop: "integralNum",
          width: 100,
        },
        {
          i18nKey: "header.accountCenter.columns.bonusPoints",
          prop: "giveNum",
          width: 100,
        },
        {
          i18nKey: "header.accountCenter.columns.paymentMethod",
          prop: "paymentType",
          width: 120,
        },
        {
          i18nKey: "header.accountCenter.columns.orderTime",
          prop: "gmtCreate",
          width: 170,
        },
      ], //订单管理列表表头
      useTotal: 0,
      orderTotal: 0,
      usePageNum: 1,
      orderPageNum: 1,
      usePageSize: 10,
      orderPageSize: 10,
      messageUnreadCount: 0,
      aiTaskRunningCount: 0,
      messageUnreadTimer: null,
      messageUnreadLoading: false,
      helpMenuOpen: false,
    };
  },
  computed: {
    isManyuLogo() {
      return this.$store.state.logoImage === "logo-manyu";
    },
    isShenglianyunLogo() {
      return ["logo-shenglianyun", "logo-xinxixi"].includes(
        this.$store.state.logoImage,
      );
    },
    logoSrc() {
      return (
        this.$utils.get_system_logo(this.$store.state.logoImage) ||
        this.$utils.get_system_logo("logo-manyu")
      );
    },
    finalMenuItems() {
      let menuItems = [
        {
          id: 0,
          icon: "account",
          text: "账户",
          i18nKey: "header.accountCenter.nav.account",
          width: 17,
          height: 17,
        },
        {
          id: 3,
          icon: "order",
          text: "充值记录",
          i18nKey: "header.accountCenter.nav.rechargeRecords",
          width: 20,
          height: 20,
        },
        {
          id: 2,
          icon: "use",
          text: "使用情况",
          i18nKey: "header.accountCenter.nav.usage",
          width: 20,
          height: 20,
        },
      ];
      if (this.$store.state.isCloseVip) {
        menuItems = menuItems.filter((item) => item.text !== "充值记录");
      }
      return menuItems;
    },
    accountSectionTitle() {
      const activeItem = this.finalMenuItems.find(
        (item) => item.text === this.informationPop,
      );
      return activeItem ? this.$t(activeItem.i18nKey) : this.informationPop;
    },
    showMenuItems() {
      var that = this;
      return that.menuItems.filter(function (item) {
        if (
          item.id === 11 &&
          (["logo-shenglianyun", "logo-xinxixi"].includes(
            that.$store.state.logoImage,
          ) ||
            that.$store.state.isYueEdition)
        ) {
          return false;
        }
        if (item.id === 10 && ["en-US", "yue"].includes(that.$i18n.locale)) {
          return false;
        }
        if (item.text === "个人中心" && that.$store.state.isCloseVip) {
          return false;
        }
        if (item.text === "充值记录") {
          return that.isCloseVip;
        }
        if (item.text === "备案信息") {
          return !that.$store.state.isCloseVip;
        }
        if (item.text === "账户管理") {
          return (
            Number(that.$store.state.userClientType) ===
              CLIENT_TYPE.ENTERPRISE && isManager(that.user)
          );
        }
        if (item.text === "团队管理") {
          return (
            Number(that.$store.state.userClientType) ===
              CLIENT_TYPE.ENTERPRISE && isManager(that.user)
          );
        }
        return true;
      });
    },
    passwordRules() {
      const rules = {
        newPassword: [
          {
            required: true,
            message: this.$t("header.passwordDialog.enterNewPassword"),
            trigger: "blur",
          },
        ],
        confirmNewPassword: [
          {
            required: true,
            validator: this.validateConfirmPassword,
            trigger: "blur",
          },
        ],
      };
      if (this.passwordConfigured === true) {
        rules.password = [
          {
            required: true,
            message: this.$t("header.passwordDialog.enterOldPassword"),
            trigger: "blur",
          },
        ];
      }
      return rules;
    },
    customRechargeIntegral() {
      const baseIntegral =
        Number(this.customRechargeAmount || 0) * this.customRechargeRate;
      return (
        baseIntegral +
        Math.floor((baseIntegral * this.customRechargeGiveRate) / 100)
      );
    },
    payableAmount() {
      if (this.rechargeSelectionMode === "custom") {
        return Number(this.customRechargeAmount || 0);
      }
      if (
        this.rechargeSelectionMode === "package" &&
        this.selectedPackageIndex !== null
      ) {
        const item = this.packages[this.selectedPackageIndex];
        return item ? Number(item.moneyNum || 0) : 0;
      }
      return 0;
    },
    payableAmountDisplay() {
      if (this.rechargeSelectionMode === "custom") {
        return this.customRechargeAmount || "0";
      }
      if (
        this.rechargeSelectionMode === "package" &&
        this.selectedPackageIndex !== null
      ) {
        const item = this.packages[this.selectedPackageIndex];
        return item && item.moneyNum !== undefined && item.moneyNum !== null
          ? String(item.moneyNum)
          : "0";
      }
      return "0";
    },
    payablePoints() {
      if (this.rechargeSelectionMode === "custom") {
        return this.customRechargeIntegral;
      }
      if (
        this.rechargeSelectionMode === "package" &&
        this.selectedPackageIndex !== null
      ) {
        const item = this.packages[this.selectedPackageIndex];
        return item ? this.getPackageTotalIntegral(item) : 0;
      }
      return 0;
    },
    subscriptionTriggerLabel() {
      return this.$store.state.subscriptionPlanMeta.activityName || "";
    },
    subscriptionButtonHidden() {
      return isSubscriptionButtonHidden(this.user);
    },
    // 顶栏套餐入口：个人客户或超级管理员可见
    canShowMembershipPurchase() {
      return !this.subscriptionButtonHidden && canPurchaseMembership(this.user);
    },
    // canShowStatisticalDimension() {
    //   return Number(this.user.roleId || this.$getRoleId()) === 1;
    // },
  },
  created() {
    var user = JSON.parse(window.localStorage.getItem("user"));
    if (!user) {
      window.localStorage.removeItem("token");
    } else {
      this.user = user;
      syncSubscriptionAccountTypeFromUser(this.$store);
    }
  },
  mounted() {
    if (this.user) {
      this.$store.dispatch("fetchSubscriptionPlans").catch(() => {});
      this.$store.dispatch("fetchUserSubscription").catch(() => {});
    }
    this.getRechargePackage();
    // this.getVipPackage();
    this.earnPoints();
    if (!this.accountOnly) {
      this.fetchMessageUnreadCount();
      this.messageUnreadTimer = window.setInterval(
        this.fetchMessageUnreadCount,
        MESSAGE_UNREAD_POLL_INTERVAL,
      );
    }
    // this.getOrderList();
    // this.getUsage();

    bus.$on("earnPoints", () => {
      this.earnPoints();
      // this.freeIntegral = data.freeIntegral;
      // this.topUpIntegral = data.topUpIntegral;
      // this.allTotal = data.total;
      // this.vipIntegral = data.vipIntegral;
      // this.vipType = data.vipType;
      // this.validTime = data.validTime;
    });
    bus.$on("openRecharge", this.openRechargeDialog);
    bus.$on("openMemberCenter", this.openMemberCenterFromBus);
    bus.$on("openSubscriptionPromotion", this.openSubscriptionPromotion);
    if (window.sessionStorage.getItem(PENDING_ACTIVITY_KEY) === "1") {
      this.$nextTick(this.openSubscriptionPromotion);
    }
    document.addEventListener("click", this.closeHelpMenuOnOutsideClick);
  },
  beforeDestroy() {
    bus.$off("openRecharge", this.openRechargeDialog);
    bus.$off("openMemberCenter", this.openMemberCenterFromBus);
    bus.$off("openSubscriptionPromotion", this.openSubscriptionPromotion);
    document.removeEventListener("click", this.closeHelpMenuOnOutsideClick);
    this.clearUserPopoverTimer();
    this.clearBeianPopoverTimer();
    if (this.messageUnreadTimer) {
      clearInterval(this.messageUnreadTimer);
      this.messageUnreadTimer = null;
    }
  },
  watch: {
    "$route.path": {
      handler(val) {
        console.log(val);
        // 特殊路由处理
        if (
          val === "/projectManagement" ||
          val === "/scriptPage" ||
          val === "/scriptPreviewPage"
        ) {
          this.activeIndex = "/myProject";
          return;
        }
        // 画布工作台挂在画布路由下，保持顶栏画布高亮
        if (val.indexOf("/visionCanvas") === 0) {
          this.activeIndex = "/visionCanvas";
          return;
        }
        const currentTab = this.tabData.find((tab) => tab.url === val);
        if (currentTab) {
          console.log(currentTab);
          this.activeIndex = currentTab.url;
        } else {
          this.activeIndex = "/";
        }
      },
      immediate: true,
    },
    // 充值弹窗每次打开都重新拉档位和自定义金额单价：
    // head.vue 只挂载一次，后台改价后如果不重拉，整个会话都会停留在开屏时的旧价目
    visible(opened) {
      if (opened) {
        this.getRechargePackage();
      }
    },
  },
  methods: {
    handleMenuOpen(index) {
      if (index === "help") this.helpMenuOpen = true;
    },
    handleMenuClose(index) {
      if (index === "help") this.helpMenuOpen = false;
    },
    async fetchMessageUnreadCount() {
      if (this.messageUnreadLoading) return;
      if (!window.localStorage.getItem("token")) {
        this.messageUnreadCount = 0;
        this.aiTaskRunningCount = 0;
        return;
      }
      this.messageUnreadLoading = true;
      try {
        const response = await this.$axios.get(
          `${this.$store.state.serverUrl}ytb/workOrder/message/unreadCount`,
        );
        const body = response && response.data;
        if (!body || (body.code !== undefined && Number(body.code) !== 200)) {
          return;
        }
        const data = body.data !== undefined ? body.data : body;
        const count =
          data && typeof data === "object"
            ? data.workOrderUnreadCount ?? data.unreadCount ?? data.count
            : data;
        if (Number.isFinite(Number(count))) {
          this.messageUnreadCount = Math.max(0, Number(count));
        }
        if (data && typeof data === "object" && Number.isFinite(Number(data.aiTaskRunningCount))) {
          this.aiTaskRunningCount = Math.max(0, Number(data.aiTaskRunningCount));
        }
      } catch (error) {
        // Keep the last known count when polling is temporarily unavailable.
      } finally {
        this.messageUnreadLoading = false;
      }
    },
    closeHelpMenuOnOutsideClick(event) {
      const helpMenu = this.$refs.helpMenu;
      if (helpMenu && !helpMenu.$el.contains(event.target)) {
        this.$refs.navMenu.close("help");
        this.helpMenuOpen = false;
      }
    },
    changeLocale(locale) {
      if (locale === this.$i18n.locale) return;
      setLocale(locale);
      window.location.reload();
    },
    handleLogoClick() {
      if (this.isManyuLogo && this.$route.path !== "/login") {
        this.$router.push("/login");
      }
    },
    clearUserPopoverTimer() {
      if (this.userPopoverTimer) {
        clearTimeout(this.userPopoverTimer);
        this.userPopoverTimer = null;
      }
    },
    clearBeianPopoverTimer() {
      if (this.beianPopoverTimer) {
        clearTimeout(this.beianPopoverTimer);
        this.beianPopoverTimer = null;
      }
    },
    openUserPopover() {
      this.userPopoverHovering = true;
      this.clearUserPopoverTimer();
      this.userPopoverVisible = true;
    },
    scheduleCloseUserPopover() {
      this.userPopoverHovering = false;
      this.queueCloseUserPopover();
    },
    queueCloseUserPopover() {
      this.clearUserPopoverTimer();
      this.userPopoverTimer = setTimeout(() => {
        if (!this.beianPopoverVisible && !this.userPopoverHovering) {
          this.blurActivePopoverElement();
          this.userPopoverVisible = false;
        }
        this.userPopoverTimer = null;
      }, 220);
    },
    openBeianPopover() {
      this.clearUserPopoverTimer();
      this.clearBeianPopoverTimer();
      this.userPopoverVisible = true;
      this.beianPopoverVisible = true;
    },
    scheduleCloseBeianPopover() {
      this.clearBeianPopoverTimer();
      this.beianPopoverTimer = setTimeout(() => {
        this.blurActivePopoverElement();
        this.beianPopoverVisible = false;
        this.beianPopoverTimer = null;
        this.queueCloseUserPopover();
      }, 220);
    },
    blurActivePopoverElement() {
      const activeElement = document.activeElement;
      if (
        !activeElement ||
        activeElement === document.body ||
        typeof activeElement.closest !== "function"
      ) {
        return;
      }

      if (
        activeElement.closest(".user-menu-popover") ||
        activeElement.closest(".beian-popover")
      ) {
        activeElement.blur();
      }
    },
    hideUserPopovers() {
      this.clearUserPopoverTimer();
      this.clearBeianPopoverTimer();
      this.blurActivePopoverElement();
      this.userPopoverHovering = false;
      this.beianPopoverVisible = false;
      this.userPopoverVisible = false;
    },
    disablePassword() {
      this.form.password = "";
      this.form.newPassword = "";
      this.form.confirmNewPassword = "";
      this.passwordConfigured = true;
      this.$refs.form.resetFields();
    },
    checkPasswordStatus() {
      this.passwordConfigured = null;
      return this.$axios
        .get(this.$store.state.serverUrl + "ytb/user/password/status")
        .then((result) => {
          const response = result && result.data;
          const payload = response && response.data;
          const candidates = [
            payload,
            payload && payload.hasPassword,
            payload && payload.passwordSet,
            payload && payload.configured,
            payload && payload.exists,
            payload && payload.status,
            response && response.hasPassword,
            response && response.passwordSet,
            response && response.configured,
            response && response.status,
          ];
          const value = candidates.find(
            (candidate) =>
              typeof candidate === "boolean" ||
              candidate === 0 ||
              candidate === 1 ||
              candidate === "0" ||
              candidate === "1",
          );
          if (value === undefined) {
            throw new Error("Password status response is invalid");
          }
          this.passwordConfigured = value === true || value === 1 || value === "1";
        })
        .catch(() => {
          this.passwordConfigured = true;
        });
    },
    /** 保存密码 */
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$axios
            .get(
              this.$store.state.serverUrl +
                "ytb/user/update/password?oldPassword=" +
                this.form.password +
                "&newPassword=" +
                this.form.newPassword,
            )
            .then((result) => {
              // 返回信息
              let response = result.data;
              // code==0为成功，其余是失败或异常
              if (response.code == 200) {
                this.$message({
                  message: this.$t("header.passwordDialog.success"),
                  type: "success",
                  offset: 100,
                });
                window.localStorage.removeItem("token");
                window.localStorage.removeItem("user");
                this.$router.push("/login");
              } else {
                this.$message({
                  message: result.data.message,
                  type: "error",
                  offset: 100,
                });
              }
            })
            .catch((error) => {});
        }
      });
    },

    handleSelect(key) {
      if (key === "/feedback") {
        this.feedbackDialogVisible = true;
        this.activeIndex = "";
        this.$nextTick(function () {
          this.resetMenuActiveIndex();
        });
        return;
      }
      if (key === "/productUpdates") {
        this.changelogDialogVisible = true;
        this.activeIndex = "";
        this.$nextTick(function () {
          this.resetMenuActiveIndex();
        });
        return;
      }
      if (key === "/operationGuide") {
        const localeOverride =
          this.$i18n.locale === "en-US"
            ? HELP_MANUAL_URL_OVERRIDE_EN || HELP_MANUAL_URL_OVERRIDE
            : HELP_MANUAL_URL_OVERRIDE;
        const helpManualUrl =
          localeOverride ||
          (this.isManyuLogo ? MANYU_HELP_MANUAL_URL : DEFAULT_HELP_MANUAL_URL);
        window.open(helpManualUrl, "_blank", "noopener");
        this.activeIndex = "";
        this.$nextTick(function () {
          this.resetMenuActiveIndex();
        });
        return;
      }
      if (key === "/hotRanking") {
        this.$message({
          message: this.$t("header.messages.comingSoon"),
          type: "info",
          offset: 100,
        });
        this.activeIndex = "";
        this.$nextTick(function () {
          this.resetMenuActiveIndex();
        });
        return;
      }
      this.activeIndex = key;
      if (key === "/copywritingCreation") {
        bus.$emit("openCreationScripts");
      }
      // 原逻辑：（泫宗）画布曾新开窗口跳转，需重置菜单高亮；现为页面路由，保留备用
      // if (key === "/visionCanvas") {
      //   this.resetMenuActiveIndex();
      // }
    },
    resetMenuActiveIndex() {
      const val = this.$route.path;
      if (val === "/projectManagement" || val === "/scriptPage") {
        this.activeIndex = "/myProject";
        return;
      }
      // 画布工作台与编辑器都在 /visionCanvas 下，保持顶栏画布高亮
      if (val.indexOf("/visionCanvas") === 0) {
        this.activeIndex = "/visionCanvas";
        return;
      }
      const currentTab = this.tabData.find((tab) => tab.url === val);
      this.activeIndex = currentTab ? currentTab.url : val;
    },
    handleCurrentChange(page) {
      this.usePageNum = page; // 更新当前页码
      this.getUsage(); // 刷新使用情况列表
    },
    handleOrderCurrentChange(page) {
      this.orderPageNum = page; // 更新当前页码
      this.getOrderList(); // 刷新订单列表
    },
    /**退出登录 */
    logout() {
      this.hideUserPopovers();
      this.show = true;
      this.popUpWindowType = "logout";
    },
    menuSwitching(item) {
      this.informationPop = item.text == "会员兑换" ? "账户" : item.text; // 切换到对应的菜单项
    },
    switchRechargeType(item) {
      this.rechargeType = item;
    },
    exchange() {
      if (this.vipCode.trim() == "") {
        this.$message.warning("请输入兑换码！");
        return;
      }
      this.exchangeLoading = true;
      var url = this.$store.state.serverUrl + "ytb/vipRedeem/user/redeem";
      var data = {
        vipCode: this.vipCode,
      };
      this.$axios.post(url, data).then((res) => {
        this.exchangeLoading = false;
        if (res.data.code == 200) {
          this.$message.success("兑换成功！");
          this.vipCode = "";
          this.getUsage(); // 刷新使用情况列表
          this.getOrderList(); // 刷新订单列表
          this.earnPoints();
        } else {
          this.$message.error(res.data.message);
        }
      });
    },

    doSomething() {
      this.resetRechargeSelection();
      this.visible = true;
    },
    openSubscriptionDialog() {
      // 非超管企业账号（管理员/成员）禁止打开订阅购买面板
      if (!this.canShowMembershipPurchase) return;
      this.hideUserPopovers();
      this.subscriptionVisible = true;
    },
    openSubscriptionPromotion() {
      window.sessionStorage.removeItem(PENDING_ACTIVITY_KEY);
      this.hideUserPopovers();
      this.subscriptionVisible = true;
    },
    openMemberCenter(tab = "subscription", options = {}) {
      this.hideUserPopovers();
      this.memberCenterTab = tab;
      // 默认不自动打开增席；仅套餐页跳转时传入 autoOpenAddSeats
      this.memberCenterAutoOpenAddSeats = Boolean(options.autoOpenAddSeats);
      this.memberCenterVisible = true;
    },
    openUsagePanel() {
      this.hideUserPopovers();
      if (this.$store.state.isCloseVip) {
        this.accountPop = true;
        this.informationPop = "使用情况";
        this.getUsage();
        return;
      }
      this.openMemberCenter("usage");
    },
    openMemberCenterFromBus(tab = "subscription") {
      const nextTab = tab && typeof tab === "object" && tab.tab ? tab.tab : tab;
      this.openMemberCenter(nextTab || "subscription");
    },
    openSubscriptionFromMemberCenter() {
      this.memberCenterVisible = false;
      this.openSubscriptionDialog();
    },
    // 套餐弹窗「新增席位」：关闭套餐页并打开个人中心增席流程
    openAddSeatsFromSubscription() {
      this.subscriptionVisible = false;
      this.openMemberCenter("recharge", { autoOpenAddSeats: true });
    },
    // 增席弹窗已按指令打开（或已判定无需打开），复位避免下次误触发
    onMemberCenterAddSeatsOpened() {
      this.memberCenterAutoOpenAddSeats = false;
    },
    openRechargeDialog(options = {}) {
      this.rechargeType = options.type || "points";
      this.resetRechargeSelection();
      this.visible = true;
    },
    /**非空校验 */
    nonNullCheck(val) {
      if (val === null || val === "" || val === undefined) {
        return "--";
      } else {
        return val;
      }
    },
    startCountdown() {
      this.resetCountdown();
      this.countdown = 3; //倒计时秒数
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.closeDialog();
        }
      }, 1000);
    },
    resetCountdown() {
      this.countdown = 0;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    closeDialog() {
      this.payResultPop = false;
      this.resetCountdown();
    },
    turnOffQRCode() {
      clearInterval(this.timerId);
      this.selectedRechargePackage = null;
    },
    /**用户点击完成支付 */
    completePayment() {
      this.payInState(); // 立即查询支付状态
      this.payResultPop = true; // 显示支付结果弹窗
      this.payPopupWindow = false; // 关闭支付弹窗
      this.rechargePop = false; // 关闭充值弹窗
      this.startCountdown();
      clearInterval(this.timerId); // 清除定时器
    },
    onConfirm(payload) {
      console.log("确认操作类型：", payload.type);
      // 做删除、退出等具体业务
      if (payload.type == "logout") {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("user");
        window.localStorage.removeItem("id");
        window.localStorage.removeItem("company");
        window.localStorage.removeItem("selectNumber");
        window.localStorage.removeItem("firstLogin");
        window.localStorage.removeItem("registerGiftIntegral");
        window.localStorage.removeItem("permissions");
        // 退出时清掉未确认的登录公告，避免串到下一账号会话
        clearPendingAnnouncement();
        this.$store.commit("setUserClientType", null);
        this.$store.commit("setSubscriptionAccountType", "personal");
        // 登录成功 or 退出
        clearPermissionCache();
        window.dispatchEvent(new CustomEvent("auth-token-changed"));
        this.$emit("logout-success");
        this.$router.push("/login");
      } else if (payload.type == "insufficientPoints") {
        this.rechargePop = true; // 打开充值弹窗
      } else if (payload.type == "activateMembership") {
        this.rechargePop = true; // 打开充值弹窗
      }
    },
    onCancel(payload) {
      console.log("取消/关闭 操作类型：", payload.type);
      this.deletedUserData = null;
      this.deletedData = null;
      this.editInput = "";
    },
    confirmRecharge(item, index, payType, customAmount) {
      this.rechargeLoad = true;
      this.selectedRechargePackage = null;
      // ytb/order/trade/page/pay/
      // ytb/order/create/order/
      let url = "ytb/order/create/order/comic/";
      const paymentName = this.paymentMethod == "1" ? "微信" : "支付宝";
      const amountPath = customAmount ? "/" + customAmount : "/" + "0";
      this.$axios
        .post(
          this.$store.state.serverUrl +
            url +
            item.id +
            "/" +
            // payType +
            // "/" +
            paymentName +
            amountPath,
        )
        .then((res) => {
          this.rechargeLoad = false;
          if (res.data.code == 200) {
            let img = QRCode.toDataURL(res.data.data.codeUrl, {
              width: "162",
              height: "162",
            });
            img.then((t) => {
              this.qrCodeImgUrl = t;
            });
            this.outTradeNo = res.data.data.outTradeNo;
            this.selectedRechargePackage = item;
            this.payPopupWindow = true;

            this.timerId = setInterval(() => {
              this.payInState("automaticPolling");
            }, 1500);
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    confirmCustomRecharge() {
      const amount = this.customRechargeAmount;
      if (!CUSTOM_RECHARGE_AMOUNT_PATTERN.test(amount)) {
        this.$message.warning("请输入充值金额");
        return;
      }
      this.confirmRecharge(
        {
          id: 10,
          moneyNum: amount,
          isCustomAmount: true,
        },
        null,
        1,
        amount,
      );
    },
    resetRechargeSelection() {
      this.selectedPackageIndex = null;
      this.rechargeSelectionMode = "";
      this.customRechargeAmount = "";
    },
    formatRechargeNumber(value) {
      return Number(value || 0).toLocaleString(this.getNumberLocale());
    },
    getNumberLocale() {
      return this.$i18n.locale === "yue" ? "zh-HK" : this.$i18n.locale;
    },
    formatMoneyAmount(value) {
      if (value === null || value === undefined || value === "") {
        return "0";
      }
      const raw = String(value).replace(/,/g, "");
      const num = Number(raw);
      if (Number.isNaN(num)) {
        return raw;
      }
      if (raw.includes(".")) {
        const fractionDigits = raw.split(".")[1].length;
        return num.toLocaleString(this.getNumberLocale(), {
          minimumFractionDigits: fractionDigits,
          maximumFractionDigits: fractionDigits,
        });
      }
      return num.toLocaleString(this.getNumberLocale());
    },
    isRechargePackageSelected(index) {
      return (
        this.rechargeSelectionMode === "package" &&
        this.selectedPackageIndex === index
      );
    },
    isRechargeValuePackage(index) {
      return index === this.packages.length - 1;
    },
    selectRechargePackage(item, index) {
      this.rechargeSelectionMode = "package";
      this.selectedPackageIndex = index;
      this.customRechargeAmount = "";
    },
    selectCustomRechargeMode() {
      if (this.rechargeSelectionMode !== "custom") {
        this.rechargeSelectionMode = "custom";
        this.selectedPackageIndex = null;
      }
    },
    handlePayNow() {
      if (this.rechargeSelectionMode === "custom") {
        this.confirmCustomRecharge();
        return;
      }
      if (
        this.rechargeSelectionMode === "package" &&
        this.selectedPackageIndex !== null
      ) {
        const item = this.packages[this.selectedPackageIndex];
        if (item) {
          this.confirmRecharge(item, this.selectedPackageIndex, 1);
        }
        return;
      }
      this.$message.warning("请选择套餐或输入充值金额");
    },
    handleCustomAmountInput(event) {
      const rawValue = event.target.value || "";
      let amount = rawValue.replace(/\D/g, "").replace(/^0+/, "");
      if (rawValue && !amount) {
        amount = "1";
      }
      amount = amount.slice(0, CUSTOM_RECHARGE_AMOUNT_MAX_LENGTH);
      this.customRechargeAmount = amount;
      this.rechargeSelectionMode = "custom";
      this.selectedPackageIndex = null;
      event.target.value = amount;
    },
    getPackageIntegral(item) {
      if (!item) return "--";
      if (item.isCustomAmount) {
        const baseIntegral =
          Number(item.moneyNum || 0) * this.customRechargeRate;
        const totalIntegral =
          baseIntegral +
          Math.floor((baseIntegral * this.customRechargeGiveRate) / 100);
        return totalIntegral + "积分";
      }
      if (item.integralTotal !== undefined && item.integralTotal !== null) {
        return item.integralTotal + "积分";
      }
      const integralNum = Number(item.integralNum || 0);
      const giveNum = Number(item.giveNum || 0);
      return integralNum + giveNum + "积分";
    },
    getPackageBaseIntegral(item) {
      if (!item) return "--";
      return Number(item.integralNum || 0);
    },
    getPackageGiveIntegral(item) {
      if (!item) return 0;
      return Number(item.giveNum || 0);
    },
    getPackageTotalIntegral(item) {
      if (!item) return 0;
      const integralNum = Number(item.integralNum || 0);
      const giveNum = Number(item.giveNum || 0);
      const integralTotal = Number(item.integralTotal || 0);
      return Math.max(integralTotal, integralNum + giveNum);
    },
    getPackageMoney(item) {
      if (!item || item.moneyNum === undefined || item.moneyNum === null) {
        return "--";
      }
      return "¥ " + item.moneyNum;
    },
    /**轮询支付状态 */
    payInState(type) {
      this.$axios
        .get(
          this.$store.state.serverUrl +
            "ytb/order/select/order/state?outTradeNo=" +
            this.outTradeNo +
            "&paymentType=" +
            (this.paymentMethod == "1" ? "微信" : "支付宝"),
          { multipleCancel: true },
        )
        .then((res) => {
          if (res.data.code == 200 && res.data.data == "SUCCESS") {
            this.payResultPop = true;
            clearInterval(this.timerId);
            this.payPopupWindow = false;
            this.rechargePop = false;
            this.payResultMessage = true;
            this.visible = false;
            this.earnPoints();
            bus.$emit("allPoints"); // 连接全局子组件
            bus.$emit("teamManagementRefresh");
            this.getUsage(); // 刷新使用情况列表
            this.getOrderList(); // 刷新订单列表
            if (type == "automaticPolling") {
              this.startCountdown();
            }
          } else {
            // this.payResultPop = true;
            this.payResultMessage = false;
          }
        });
    },
    /**获取积分数据 */
    earnPoints() {
      this.$axios
        .get(this.$store.state.serverUrl + "ytb/user/select/userById")
        .then((res) => {
          if (res.data.code == 200) {
            let data = res.data.data;
            this.freeIntegral = data.freeIntegral;
            this.topUpIntegral = data.topUpIntegral;
            this.allTotal = data.total;
            this.vipIntegral = data.vipIntegral;
            this.vipType = data.vipType;
            this.validTime = data.validTime;
            persistUserFields({ vipType: data.vipType });
            this.$store.commit("setUserSubscriptionInfo", {
              vipType: Number(data.vipType || 0),
            });
            function setPoint(list, key, value) {
              var item = list.find(function (i) {
                return i.key === key;
              });
              if (item) item.value = value;
            }
            setPoint(
              this.infoRows,
              "身份",
              this.vipType == 0 ? "普通用户" : "会员",
            );
            setPoint(
              this.infoRows,
              "会员到期时间",
              this.vipType == 0 ? "--" : this.validTime,
            );
            setPoint(this.points, "免费积分", this.freeIntegral);
            setPoint(this.points, "补充积分", this.topUpIntegral);
            setPoint(this.points, "total", this.allTotal);
            setPoint(this.points, "subscription", this.vipIntegral);
            setPoint(this.infoRows, "registeredAt", this.user.createTime);
            setPoint(this.infoRows, "account", this.user.username);
          }
        });
    },
    /**获取充值套餐 */
    getRechargePackage() {
      this.$axios({
        method: "get",
        url:
          this.$store.state.serverUrl + "ytb/order/select/integralTopUpComic",
      }).then((res) => {
        if (res.data.code == 200) {
          this.packages = res.data.data || [];
          var compare = (prop) => {
            return (obj1, obj2) => {
              var val1 = obj1[prop];
              var val2 = obj2[prop];
              if (val1 < val2) {
                return -1;
              } else if (val1 > val2) {
                return 1;
              } else {
                return 0;
              }
            };
          };
          this.packages.sort(compare("sort"));
          console.log(this.packages);
          this.getCustomRechargeConfig();
        } else {
          console.error(res.data.message);
        }
      });
    },

    /**获取自定义金额充值的基础积分单价和赠送比例 */
    getCustomRechargeConfig() {
      this.$axios({
        method: "get",
        url:
          this.$store.state.serverUrl + "ytb/order/select/integralCustomConfig",
      })
        .then((res) => {
          const config = (res.data && res.data.data) || {};
          const rate = Number(config.rate);
          const giveRate = Number(config.giveRate);
          if (res.data.code == 200 && Number.isFinite(rate) && rate > 0) {
            this.customRechargeRate = rate;
            this.customRechargeGiveRate =
              Number.isFinite(giveRate) && giveRate > 0 ? giveRate : 0;
          }
        })
        .catch(() => {
          // 取不到配置时保留默认值，自定义金额换算不至于显示为 0
        });
    },

    /**获取会员套餐 */
    getVipPackage() {
      this.$axios({
        method: "get",
        url: this.$store.state.serverUrl + "ytb/order/select/vipTopUpSelect",
      }).then((res) => {
        if (res.data.code == 200) {
          this.vipPackages = res.data.data || [];
        } else {
          console.error(res.data.message);
        }
      });
    },
    /**获取使用情况列表 */
    getUsage() {
      this.useLoading = true; // 开始加载订单数据
      this.$axios({
        method: "post",
        url: this.$store.state.serverUrl + "ytb/order/select/order/log",
        data: {
          logType: 1,
          pageNum: this.usePageNum,
          pageSize: this.usePageSize,
        },
      }).then((res) => {
        this.useLoading = false; // 结束加载订单数据
        if (res.data.code == 200) {
          console.log(res.data);
          this.tableData = res.data.data.list || [];
          this.useTotal = res.data.data.total || 0;
        } else {
          console.error(res.data.message);
        }
      });
    },
    /**获取订单列表 */
    getOrderList() {
      this.orderLoading = true; // 开始加载订单数据
      this.$axios({
        method: "post",
        url: this.$store.state.serverUrl + "ytb/order/select/order/log",
        data: {
          logType: 2,
          pageNum: this.orderPageNum,
          pageSize: this.orderPageSize,
        },
      }).then((res) => {
        this.orderLoading = false; // 结束加载订单数据
        if (res.data.code == 200) {
          console.log(res.data);
          this.orderListData = res.data.data.list || [];
          this.orderTotal = res.data.data.total || 0;
        } else {
          console.error(res.data.message);
        }
      });
    },
    getAgreementUrl(type) {
      const base = (process.env.BASE_URL || "/").replace(/\/?$/, "/");
      const params = new URLSearchParams({
        type,
        logoImage: (this.$store && this.$store.state.logoImage) || "",
      });
      return `${base}legal/index.html?${params.toString()}`;
    },
    openInformation(item) {
      this.hideUserPopovers();
      if (item == "问题反馈") {
        this.feedbackDialogVisible = true;
        return;
      }
      if (item == "联系我们") {
        this.contactDialogVisible = true;
        return;
      }
      // 打开更新日志全屏窗口
      if (item == "更新日志") {
        this.changelogDialogVisible = true;
        return;
      }
      if (item == "修改密码") {
        this.passwordPop = true;
        this.checkPasswordStatus();
        return;
      }
      if (item == "个人中心") {
        this.openMemberCenter("subscription");
        return;
      }
      if (item == "账户管理") {
        this.$router.push("/userManagement");
        return;
      }
      if (item == "团队管理") {
        this.$router.push("/teamManagement");
        return;
      }
      if (item == "开发票") {
        this.$router.push("/invoice");
        return;
      }
      if (item == "用户协议与隐私") {
        window.open(`${process.env.BASE_URL}legal/index.html`, "_blank");
        return;
      }
      this.accountPop = true;
      this.informationPop = item == "会员兑换" ? "账户" : item;
      this.getUsage(); // 刷新使用情况列表
      this.getOrderList(); // 刷新订单列表
    },
    jump(item) {
      this.selectTab = item.id;
      this.$router.push(item.url);
      // bus.$emit("tabEvent", item.id); // 连接全局子组件
    },
    headerBtnClick() {
      this.doSomething(); // 这是你想让它执行的事件
    },
    handlePointsUpdated(payload = {}) {
      this.allTotal = Number(payload.totalPoints || 0);
      this.topUpIntegral = Number(payload.directPoints || 0);
      this.vipIntegral = Number(payload.subscriptionPoints || 0);

      function setPoint(list, key, value) {
        var item = list.find(function (i) {
          return i.key === key;
        });
        if (item) item.value = value;
      }

      setPoint(this.points, "total", this.allTotal);
      setPoint(this.points, "direct", this.topUpIntegral);
      setPoint(this.points, "subscription", this.vipIntegral);
    },
  },
};
</script>
<style>
.user-card-popover {
  padding: 1.07143rem !important;
  background: #2a2f36 !important;
  border: 1px solid #2a2f36;
}
.user-menu-popover {
  padding: 0 !important;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}
.user-menu-popover[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: rgba(51, 56, 78, 0.85) !important;
}
.user-menu-popover[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: #11121b !important;
}
.el-menu--popup {
  min-width: 11rem !important;
}
.beian-popover.el-popover {
  padding: 0.85714rem 1rem;
  background: #11121b;
  border: 1px solid rgba(51, 56, 78, 0.85);
  color: #cfd3da;
}
.beian-popover .beian-panel-link {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.57143rem 0.71429rem;
  margin-bottom: 0.28571rem;
  border-radius: 0.42857rem;
  color: #e6e8ec;
  font-size: max(12PX, 1rem);
  text-decoration: none;
  transition: background 0.2s;
}
.beian-popover .beian-panel-link:hover {
  background: rgba(255, 255, 255, 0.08);
}
.beian-popover .beian-panel-link i {
  font-size: max(12PX, 1rem);
  color: #8b9099;
}
.beian-popover .beian-panel-divider {
  height: 1px;
  margin: 0.57143rem 0.14286rem;
  background: rgba(255, 255, 255, 0.08);
}
.beian-popover .beian-panel-info {
  padding: 0.14286rem 0.71429rem 0.28571rem;
  font-size: max(12PX, 0.85714rem);
  line-height: 1.8;
  color: #9aa0a8;
}
.beian-popover .beian-panel-record {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.28571rem;
}
.beian-popover .beian-panel-record a {
  color: #9aa0a8;
  text-decoration: none;
}
.beian-popover .beian-panel-record a:hover {
  color: #c4b5fd;
}
</style>
<style lang="less" scoped>
/deep/ .contact-service-dialog {
  background: #14151f;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0;
  box-shadow: 0 2rem 5.71429rem rgba(0, 0, 0, 0.58);
  color: #fff;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }
}

.contact-service {
  min-height: 30.28571rem;
}

.contact-service__header {
  height: 5.42857rem;
  padding: 0 1.71429rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  font-size: ~"max(12PX, 1.21429rem)";
  font-weight: 700;

  button {
    border: 0;
    background: transparent;
    color: rgba(255, 255, 255, 0.4);
    font-size: ~"max(12PX, 1.42857rem)";
    line-height: 1;
    cursor: pointer;
    transition: color 0.2s;

    &:hover {
      color: #fff;
    }
  }
}

.contact-service__body {
  padding: 1.71429rem 2.71429rem 2.14286rem;
  text-align: center;
}

.contact-service__desc {
  margin: 0 0 1.42857rem;
  color: rgba(232, 232, 244, 0.62);
  font-size: ~"max(12PX, 0.92857rem)";
  line-height: 1.8;
  text-align: left;
}

.contact-service__qr {
  width: 12.28571rem;
  height: 12.28571rem;
  margin: 0 auto 1.28571rem;
  padding: 0.85714rem;
  border-radius: 0.71429rem;
  background: #fff;

  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
  }
}

.contact-service__phone-label {
  color: rgba(232, 232, 244, 0.5);
  font-size: ~"max(12PX, 0.85714rem)";
  line-height: 1.28571rem;
}

.contact-service__phone {
  margin-top: 0.21429rem;
  color: #f4f4ff;
  font-size: ~"max(12PX, 1.28571rem)";
  font-weight: 700;
  line-height: 1.71429rem;
}

.contact-service__time {
  margin-top: 0.5rem;
  color: rgba(232, 232, 244, 0.42);
  font-size: ~"max(12PX, 0.85714rem)";
  line-height: 1.28571rem;
}

/**扫码支付弹窗 start */
/deep/.qrCodeClass {
  min-height: 25.71429rem;
  background: #13141a;
  box-shadow: 0 1.78571rem 4.28571rem rgba(0, 0, 0, 0.5);
  border-radius: 0.85714rem;
  color: #e5e7eb;
  .el-dialog__headerbtn .el-dialog__close {
    font-size: ~"max(12PX, 1.71429rem)";
    color: #94a3b8;
    font-weight: 600;
    &:hover {
      color: #fff;
    }
  }
  .el-dialog__title {
    color: #e5e7eb;
  }
  .el-dialog__body {
    color: #94a3b8;
  }
  .pay-weixin {
    min-height: 22.5rem;
  }
  .qr-pay-summary {
    display: flex;
    justify-content: space-between;
    gap: 0.85714rem;
    margin-bottom: 0.85714rem;
    padding: 0.71429rem 0.85714rem;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 0.57143rem;
    background: rgba(255, 255, 255, 0.04);
  }
  .qr-pay-summary__item {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.28571rem;
    min-width: 0;
    span {
      font-size: ~"max(12PX, 0.85714rem)";
      color: #94a3b8;
    }
    strong {
      max-width: 100%;
      font-size: ~"max(12PX, 1.07143rem)";
      font-weight: 600;
      color: #ffffff;
      line-height: 1.42857rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  .confirmPayment {
    height: 2.57143rem;
    background: linear-gradient(135deg, #a855f7, #6366f1);
    border-radius: 2rem;
    font-size: ~"max(12PX, 1.07143rem)";
    color: #ffffff;
    line-height: 2.57143rem;
    padding: 0 1.71429rem;
    display: inline-block;
    margin-top: 1.35714rem;
    cursor: pointer;
    box-shadow: 0 0.28571rem 0.85714rem rgba(99, 102, 241, 0.3);
    transition: all 0.25s;
    &:hover {
      box-shadow: 0 0.42857rem 1.42857rem rgba(99, 102, 241, 0.5);
      transform: translateY(-1px);
    }
  }
}
/**扫码支付弹窗 end*/
/**支付结果弹窗 start*/
/deep/ .payResultDialog {
  min-height: auto !important;
  .el-dialog__body {
    padding: 0 1.42857rem;
  }
  .resultTitle {
    font-size: ~"max(12PX, 1.57143rem)";
    color: #fff;
    text-align: center;
    line-height: 1.57143rem;
    font-weight: 600;
    margin-bottom: 1.42857rem;
  }
  .subtitle {
    display: flex;
    flex-direction: column;
    > span:nth-child(1) {
      font-size: ~"max(12PX, 1.14286rem)";
      font-weight: 600;
      line-height: 1.14286rem;
      text-align: center;
      color: #fff;
      margin-top: 1.07143rem;
    }
    > span:nth-child(2) {
      font-size: ~"max(12PX, 1rem)";
      color: #64748b;
      line-height: 1.5;
      text-align: center;
      margin-top: 0.78571rem;
    }
  }
  .confirmPayment {
    background: linear-gradient(135deg, #a855f7, #6366f1);
    box-shadow: 0 0.28571rem 0.85714rem rgba(99, 102, 241, 0.3);
  }
}
/**支付结果弹窗 end*/
</style>
<style lang="less" scoped>
/**账户使用情况,订单管理样式 */
/deep/ .account-table-loading-icon {
  display: none;
}

.pagingComponent {
  text-align: center;
  margin-top: auto;
  text-align: center;
  margin-bottom: 1.07143rem;
}
.acct-root {
  padding: 2rem 2.57143rem;
  background: #13141a;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.acct-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1.71429rem 3.14286rem 1.28571rem;
}

.acct-title {
  font-size: ~"max(12PX, 1.28571rem)";
  font-weight: 600;
  color: #fff;
}

.acct-actions {
  display: flex;
  align-items: center;
  gap: 0.85714rem;
}

.acct-logout {
  color: #f87171 !important;
  padding: 0;
}

.acct-close {
  width: 2.42857rem;
  height: 2.42857rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.06);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    background: rgba(255, 255, 255, 0.12);
  }
}

.acct-card {
  background: rgba(255, 255, 255, 0.04);
  border-radius: 0.85714rem;
  padding: 1.28571rem 1.57143rem;
  margin-bottom: 1.57143rem;
  box-shadow: none;
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.acct-card__title {
  font-size: ~"max(12PX, 1rem)";
  font-weight: 600;
  color: #e2e8f0;
}

.acct-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.71429rem 0;
}

.acct-row:first-of-type {
  border-top: none;
}

.acct-row__left {
  font-size: ~"max(12PX, 1rem)";
  font-weight: 500;
  line-height: 1.42857rem;
  color: #94a3b8;
}

.acct-row__right {
  font-size: ~"max(12PX, 1rem)";
  color: #e2e8f0;
}

.acct-exchange__input {
  width: 19.28571rem;
  /deep/ .el-input__inner {
    background: #24252e;
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #fff;
    border-radius: 0.42857rem;
    &:focus {
      border-color: #6f42ff;
      box-shadow: 0 0 0 0.14286rem rgba(111, 66, 255, 0.15);
    }
  }
  /deep/ .el-input__inner::placeholder {
    color: #4b5563;
  }
}

.acct-exchange__btn {
  background: linear-gradient(135deg, #a855f7, #6366f1);
  color: #fff;
  border: none;
  border-radius: 0.42857rem;
  box-shadow: 0 0.28571rem 0.85714rem rgba(99, 102, 241, 0.3);
}
.acct-exchange__btn:hover {
  background: linear-gradient(135deg, #a855f7, #6366f1);
  color: #fff;
  box-shadow: 0 0.42857rem 1.28571rem rgba(99, 102, 241, 0.45);
}

/* 积分卡片 */
.acct-points__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.08);
  height: 2.85714rem;
}

.acct-charge {
  width: 8.71429rem;
  height: 2.21429rem;
  background: linear-gradient(135deg, #a855f7, #6366f1);
  color: #fff;
  border-radius: 0.42857rem;
  padding: 0.42857rem 1.28571rem;
  box-shadow: 0 0.28571rem 0.85714rem rgba(99, 102, 241, 0.3);
  border: none;
}
.acct-points__head {
  /deep/ .el-button.is-plain:hover {
    background: linear-gradient(135deg, #a855f7, #6366f1);
    border-color: transparent;
    color: #fff;
    box-shadow: 0 0.42857rem 1.28571rem rgba(99, 102, 241, 0.45);
  }
}

.acct-points__body {
  margin-top: 0.85714rem;
  border-radius: 0.57143rem;
  padding: 0.85714rem;
}

.acct-point {
  display: flex;
  justify-content: space-between;
  padding: 0.57143rem 0;
}

.acct-point:last-child {
  border-bottom: none;
}

.acct-point__label {
  color: #64748b;
  font-size: ~"max(12PX, 0.92857rem)";
  > img {
    width: 0.92857rem;
    height: 1.14286rem;
    margin-right: 0.71429rem;
  }
}

.acct-point__val {
  color: #a78bfa;
  font-weight: 600;
}

/* 暗色表格 */
/deep/ .dark-table {
  background: #1a1b21;
  color: #e5e7eb;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0.57143rem;
  overflow: hidden;

  th {
    background: #24252e !important;
    color: #cbd5e1 !important;
    font-weight: 600;
    font-size: ~"max(12PX, 0.92857rem)";
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }
  tr {
    background: #1a1b21;
  }
  td {
    border-bottom: 1px solid rgba(255, 255, 255, 0.04);
  }
  .el-table__body tr.el-table__row--striped td {
    background: #1f2028;
  }
  .el-table__body tr:hover > td {
    background-color: rgba(111, 66, 255, 0.06) !important;
  }
  .el-table__body-wrapper::-webkit-scrollbar {
    width: 0.42857rem;
  }
  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 0.42857rem;
    background: rgba(111, 66, 255, 0.4);
  }
  .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 0.42857rem;
    background: rgba(255, 255, 255, 0.05);
  }
  &::before {
    background-color: rgba(255, 255, 255, 0.06);
  }
  &.el-table--border td,
  &.el-table--border th {
    border-right: 1px solid rgba(255, 255, 255, 0.04);
  }
}

/* 分页暗色 */
.pagingComponent {
  /deep/ .el-pagination {
    .btn-prev,
    .btn-next {
      background: #24252e;
      color: #94a3b8;
      border-radius: 0.42857rem;
    }
    .el-pager li {
      background: #24252e;
      color: #94a3b8;
      border-radius: 0.42857rem;
      &.active {
        background: linear-gradient(135deg, #a855f7, #6366f1);
        color: #fff;
      }
      &:hover:not(.active) {
        color: #a78bfa;
      }
    }
    .el-pagination__total {
      color: #64748b;
    }
  }
}
</style>
<style lang="less" scoped>
//修改密码弹窗样式
/deep/ .password-dialog {
  padding: 0;
  border-radius: 0.85714rem;
  overflow: hidden;
  min-height: 31.28571rem;
  height: auto;
  background: #13141a;
  box-shadow: 0 1.78571rem 4.28571rem rgba(0, 0, 0, 0.5);
  .el-dialog__header,
  .el-dialog__body,
  .el-dialog__footer {
    padding: 0;
  }
  .dialog-content {
    display: flex;
    height: 100%;
  }
  .el-input__inner {
    background-color: #24252e;
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: #fff;
    border-radius: 0.57143rem;
    transition: border-color 0.2s, box-shadow 0.2s;
    &:focus {
      border-color: #6f42ff;
      box-shadow: 0 0 0 0.14286rem rgba(111, 66, 255, 0.15);
    }
  }
  .el-input__inner::placeholder {
    color: #4b5563;
  }
  .resetPart {
    padding: 2rem 2.57143rem;
    > span:first-child {
      color: #fff;
      font-size: ~"max(12PX, 1.28571rem)";
      font-weight: 600;
      margin-bottom: 1.14286rem;
      display: block;
    }
    .form-name {
      > span:nth-child(1) {
        color: #f87171;
        margin-right: 0.21429rem;
      }
      color: #cbd5e1;
      font-size: ~"max(12PX, 0.92857rem)";
      font-weight: 500;
    }
    .el-button--small {
      border-radius: 0.57143rem;
      padding: 0.64286rem 1.42857rem;
    }
    .el-button--default {
      background: rgba(255, 255, 255, 0.06);
      border: 1px solid rgba(255, 255, 255, 0.12);
      color: #94a3b8;
      &:hover {
        border-color: rgba(255, 255, 255, 0.25);
        color: #fff;
        background: rgba(255, 255, 255, 0.1);
      }
    }
    .el-button--primary {
      background: linear-gradient(135deg, #a855f7, #6366f1);
      border: none;
      box-shadow: 0 0.28571rem 1.14286rem rgba(99, 102, 241, 0.35);
      &:hover {
        box-shadow: 0 0.42857rem 1.71429rem rgba(99, 102, 241, 0.5);
        transform: translateY(-1px);
      }
    }
  }
}
//个人中心弹窗样式
// 新增用户弹窗样式 end
/deep/ .account-dialog {
  padding: 0;
  border-radius: 0.85714rem;
  overflow: hidden;
  min-height: 27.85714rem;
  height: auto;
  background: #13141a;
  box-shadow: 0 1.78571rem 4.28571rem rgba(0, 0, 0, 0.5);
  .el-dialog__header,
  .el-dialog__body,
  .el-dialog__footer {
    padding: 0;
  }
  .dialog-content {
    display: flex;
    height: 100%;
  }
  /* 左侧菜单 */
  .sidebar {
    width: 15.71429rem;
    height: 50rem;
    background: #0d0e12;
    border-right: 1px solid rgba(255, 255, 255, 0.06);
    box-sizing: border-box;
    padding-top: 2.57143rem;
  }

  .logo {
    height: 2.14286rem;
    margin-bottom: 2.35714rem;
    padding: 0 0 0 2.57143rem;
    display: flex;
    align-items: center;
    > span {
      font-weight: 700;
      font-size: ~"max(12PX, 1.57143rem)";
      color: #fff;
    }
  }

  .menu {
    list-style: none;
    margin: 0;
    padding: 0 1.42857rem;
  }

  .menu-item {
    width: 12.85714rem;
    height: 2.57143rem;
    display: flex;
    align-items: center;
    color: #94a3b8;
    font-size: ~"max(12PX, 1rem)";
    cursor: pointer;
    padding-left: 1rem;
    margin-bottom: 0.42857rem;
    border-radius: 0.57143rem;
    transition: all 0.2s;
    > span:nth-child(1) {
      width: 1.42857rem;
      height: 1.42857rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 0.57143rem;
    }
    &:hover:not(.active) {
      background: rgba(255, 255, 255, 0.04);
      color: #e2e8f0;
    }
  }

  .menu-item i {
    margin-right: 0.71429rem;
  }

  .menu-item.active {
    color: #a78bfa;
    font-weight: 600;
    border-radius: 0.57143rem;
    background: rgba(111, 66, 255, 0.12);
  }

  /* 右侧主内容 */
  .main-content {
    background: #13141a;
    box-sizing: border-box;
    width: calc(100% - 15.71429rem);
    display: flex;
    flex-direction: column;
  }
  /* 积分卡片 */
  .points-card {
    background: rgba(255, 255, 255, 0.04);
    border-radius: 0.85714rem;
    padding: 1.42857rem;
    box-shadow: none;
    border: 1px solid rgba(255, 255, 255, 0.06);
    margin: 0 3.14286rem;
  }
}

/deep/ .account-dialog.account-usage-dialog {
  margin-top: 5vh !important;
  height: 90vh;
  max-height: 90vh;
  display: flex;
  flex-direction: column;

  .el-dialog__body {
    flex: 1;
    min-height: 0;
    overflow: hidden;
  }

  .dialog-content,
  .main-content {
    height: 100%;
    min-height: 0;
  }

  .sidebar {
    height: 100%;
  }
}

/deep/ .account-dialog.recharge-dialog {
  margin: 0 !important;
  width: 100% !important;
  height: 100vh;
  max-height: none;
  border-radius: 0;
  background: radial-gradient(
      circle at top center,
      rgba(109, 56, 255, 0.2),
      transparent 28%
    ),
    #06070b;
  box-shadow: none;

  .el-dialog__body {
    height: 100%;
    padding: 0;
    overflow: auto;
  }
}
</style>
<style lang="less" scoped>
.wrap {
  min-height: 27.85714rem;
  background: #13141a;
  border-radius: 0.85714rem;
  padding: 1.71429rem;
  box-sizing: border-box;
  color: #e5e7eb;
}
/* 顶部 tabs */
.tabs {
  display: flex;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  padding-bottom: 1rem;
  justify-content: space-between;
}
.tab {
  margin-right: 2.14286rem;
  font-size: ~"max(12PX, 1.14286rem)";
  color: #64748b;
  cursor: pointer;
  transition: color 0.2s;
}
.tab.active {
  color: #a78bfa;
  font-weight: 600;
  position: relative;
}
.tab.active::after {
  content: "";
  width: 100%;
  height: 0.21429rem;
  background: linear-gradient(135deg, #a855f7, #6366f1);
  position: absolute;
  bottom: -1rem;
  left: 0;
  border-radius: 0.14286rem;
}

/* 关闭按钮 */
.close {
  cursor: pointer;
  font-size: ~"max(12PX, 1.42857rem)";
  color: #64748b;
}

/* 会员到期时间 */
.expire-box {
  display: flex;
  justify-content: space-between;
  padding: 1.78571rem 0.35714rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.expire-title {
  font-size: ~"max(12PX, 1rem)";
  color: #64748b;
  margin-bottom: 0.42857rem;
}
.expire-value {
  color: #a78bfa;
  font-size: ~"max(12PX, 1.42857rem)";
  font-weight: 600;
}

/* 卡片区域 */
.cards {
  display: flex;
  justify-content: space-between;
  margin-top: 1.78571rem;
  flex-wrap: wrap;
  gap: 1.14286rem;
}

.topupcard {
  width: 13.92857rem;
  min-height: 15.14286rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0.85714rem;
  padding: 1.28571rem;
  box-sizing: border-box;
  background: #1a1b21;
  display: flex;
  flex-direction: column;
  transition: all 0.25s;
  &:hover {
    border-color: rgba(111, 66, 255, 0.3);
    box-shadow: 0 0.28571rem 1.42857rem rgba(111, 66, 255, 0.1);
    transform: translateY(-0.14286rem);
  }
}

.custom-amount {
  margin-top: 1.42857rem;
}

.custom-amount__title {
  margin-bottom: 1.14286rem;
  color: #fff;
  font-size: ~"max(12PX, 1.14286rem)";
  font-weight: 600;
}

.custom-amount__row {
  display: flex;
  align-items: center;
  gap: 1.28571rem;
  flex-wrap: wrap;
}

.custom-amount__input-wrap {
  width: 11.85714rem;
  height: 2.85714rem;
  padding: 0 0.85714rem;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 0.57143rem;
  background: #13141a;
  transition: all 0.2s;
  &:focus-within {
    border-color: #8b5cf6 !important;
    box-shadow: 0 0 0 0.14286rem rgba(139, 92, 246, 0.18);
  }
}

.custom-amount__input {
  min-width: 0;
  flex: 1;
  height: 100%;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  color: #fff;
  font-size: ~"max(12PX, 0.92857rem)";
  &::placeholder {
    color: #7b8497;
  }
}

.custom-amount__unit {
  margin-left: 0.57143rem;
  color: #fff;
  font-size: ~"max(12PX, 1.28571rem)";
  font-weight: 600;
  line-height: 1;
}

.custom-amount__tip {
  color: #fff;
  font-size: ~"max(12PX, 0.92857rem)";
  font-weight: 600;
  line-height: 1.42857rem;
}

.custom-amount__points {
  color: #a78bfa;
  font-size: ~"max(12PX, 0.92857rem)";
  font-weight: 600;
  line-height: 1.42857rem;
}

.badge {
  display: inline-block;
  padding: 0.28571rem 0.71429rem;
  border-radius: 0.57143rem;
  font-size: ~"max(12PX, 0.85714rem)";
  margin-bottom: 0.71429rem;
  color: #fff;
}
.b-blue {
  background: #5ac8fa;
}
.b-green {
  background: #34c759;
}
.b-purple {
  background: #af52de;
}
.b-red {
  background: #ff3b30;
}

.card-title {
  font-size: ~"max(12PX, 1.28571rem)";
  font-weight: 600;
  color: #fff;
  text-align: center;
}

.point-card-title {
  min-height: 3.42857rem;
}

.point-gift {
  margin-top: 0.42857rem;
  line-height: 1.2;
}

.card-price {
  font-size: ~"max(12PX, 1.64286rem)";
  font-weight: 600;
  color: #fff;
}

.point-price-row {
  justify-content: center;
  width: 100%;
}

.old-price {
  margin-left: 1.42857rem;
  font-size: ~"max(12PX, 1rem)";
  color: #4b5563;
  // text-decoration: line-through;
}

.card-days {
  font-size: ~"max(12PX, 1rem)";
  margin: 0.35714rem 0 1.07143rem;
  color: #94a3b8;
}

.desc {
  font-size: ~"max(12PX, 0.92857rem)";
  color: #64748b;
  line-height: 1.42857rem;
  margin-bottom: 1.42857rem;
}

/* 购买按钮 */
.btn {
  width: 100%;
  padding: 0.71429rem 0;
  background: linear-gradient(135deg, #a855f7, #6366f1);
  color: #fff;
  text-align: center;
  border-radius: 0.57143rem;
  font-size: ~"max(12PX, 1.07143rem)";
  cursor: pointer;
  font-weight: 500;
  margin-bottom: 0;
  margin-top: auto;
  transition: all 0.25s;
  box-shadow: 0 0.28571rem 0.85714rem rgba(99, 102, 241, 0.3);
  &:hover {
    box-shadow: 0 0.42857rem 1.42857rem rgba(99, 102, 241, 0.5);
    transform: translateY(-1px);
  }
}
/* 支付方式 */
.pay-box {
  margin-top: auto;
}
.pay-title {
  font-size: ~"max(12PX, 1rem)";
  color: #64748b;
}

.pay-list {
  display: flex;
  align-items: center;
  // width: 6.5rem;
  height: 2.42857rem;
  border-radius: 0.42857rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-left: 1.64286rem;
  justify-content: center;
  transition: all 0.2s;
}
.wxSelected {
  border: 1px solid #1aad19;
  background: rgba(26, 173, 25, 0.08);
}
.alipaySelected {
  border: 1px solid #00a3f0;
  background: rgba(0, 163, 240, 0.08);
}

.wx-icon {
  width: 2.85714rem;
  height: 2.85714rem;
  margin-right: 0.71429rem;
}

.wx-text {
  color: #1aad19;
  font-size: ~"max(12PX, 1rem)";
  font-weight: 600;
  margin-left: 0.35714rem;
}
.alipay-text {
  color: #00a3f0;
  font-size: ~"max(12PX, 1rem)";
  font-weight: 600;
  margin-left: 0.35714rem;
}

.recharge-wrap {
  width: 100%;
  min-height: 100vh;
  max-width: none;
  margin: 0;
  padding: 3.42857rem 2.85714rem 6.85714rem;
  border-radius: 0;
  background: radial-gradient(
      circle at top center,
      rgba(109, 56, 255, 0.18),
      transparent 30%
    ),
    #06070b;
  box-sizing: border-box;
  color: #f8fafc;
}

.recharge-body {
  width: 100%;
  flex: 1;
}

.recharge-top {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  margin: 0 0 2.28571rem;
}

.recharge-header {
  text-align: left;
}

.recharge-title {
  margin: 0 0 0.42857rem;
  color: #ffffff;
  font-size: ~"max(12PX, 2rem)";
  font-weight: 800;
  line-height: 2.85714rem;
}

.recharge-subtitle {
  margin: 0;
  color: #6f778b;
  font-size: ~"max(12PX, 1rem)";
  line-height: 1.57143rem;
}

.recharge-close {
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
  outline: none;
  background: rgba(255, 255, 255, 0.06);
  color: #9ca3af;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.12);
    color: #ffffff;
  }
}

.recharge-cards {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 1.14286rem;
  width: 100%;
  margin: 0 0 1.42857rem;
  flex-wrap: unset;
  justify-content: unset;
}

.recharge-card {
  position: relative;
  overflow: hidden;
  width: auto;
  min-height: 12.57143rem;
  padding: 1.57143rem 1.28571rem 1.28571rem;
  border: 1px solid rgba(51, 56, 78, 0.85);
  border-radius: 0.57143rem;
  background: #11121b;
  box-shadow: 0 1.14286rem 2.71429rem rgba(0, 0, 0, 0.22);
  text-align: center;
  cursor: pointer;
  transition: border-color 0.18s ease, transform 0.18s ease,
    box-shadow 0.18s ease;

  &:hover {
    border-color: rgba(124, 58, 237, 0.88);
    transform: translateY(-0.14286rem);
    box-shadow: 0 1.42857rem 3.42857rem rgba(0, 0, 0, 0.3);
  }

  &.active {
    border-color: #7c3aed;
    box-shadow: 0 0 0 1px rgba(124, 58, 237, 0.35),
      0 1.42857rem 3.42857rem rgba(0, 0, 0, 0.3);
  }

  .point-card-title {
    min-height: 3.71429rem;
    color: #f8fafc;
    font-size: ~"max(12PX, 1.07143rem)";
    font-weight: 800;
    line-height: 1.57143rem;
  }

  .point-gift {
    margin-top: 0.42857rem;
    color: #00d29b;
    font-size: ~"max(12PX, 0.85714rem)";
    font-weight: 700;
  }

  .point-price-row {
    justify-content: center;
    margin: 1.28571rem 0 1.14286rem;
  }
}

.currency-price {
  display: inline-flex;
  align-items: center;
  color: #ffffff;
  font-variant-numeric: tabular-nums;
  line-height: 1;
  letter-spacing: -0.02em;
}

.currency-symbol {
  margin-right: 0.14286rem;
  font-weight: 800;
  line-height: 1;
  margin: 0.42857rem 0.28571rem 0 0;
}

.currency-value {
  font-weight: 900;
  line-height: 1;
}

.currency-price--card {
  font-size: ~"max(12PX, 2rem)";

  .currency-symbol {
    font-size: ~"max(12PX, 1.14286rem)";
  }
}

.currency-price--footer {
  margin-left: 0.57143rem;
  font-size: ~"max(12PX, 1.28571rem)";

  .currency-symbol {
    font-size: ~"max(12PX, 0.78571rem)";
  }
}

.recharge-value-badge {
  position: absolute;
  top: 0;
  right: 0;
  width: 5.14286rem;
  height: 5.14286rem;
  overflow: hidden;
  pointer-events: none;

  &::before {
    content: "超值";
    position: absolute;
    top: 1rem;
    right: -1.28571rem;
    width: 6.28571rem;
    padding: 0.28571rem 0;
    background: linear-gradient(180deg, #8b5cf6, #6d28d9);
    color: #ffffff;
    font-size: ~"max(12PX, 0.78571rem)";
    font-weight: 800;
    line-height: 1.14286rem;
    text-align: center;
    transform: rotate(45deg);
  }
}

.recharge-card__button {
  width: 100%;
  height: 2.57143rem;
  margin-top: auto;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0.42857rem;
  background: rgba(25, 27, 47, 0.92);
  box-shadow: none;
  color: #d8deea;
  font-size: ~"max(12PX, 0.92857rem)";
  font-weight: 700;
  line-height: 2.42857rem;
  cursor: pointer;
  transition: background 0.18s ease, border-color 0.18s ease, color 0.18s ease;

  &:hover {
    border-color: rgba(124, 58, 237, 0.65);
    background: rgba(124, 58, 237, 0.12);
    color: #ffffff;
    box-shadow: none;
    transform: none;
  }
}

.recharge-custom {
  width: 100%;
  margin: 0;
  padding: 1.57143rem 1.71429rem 1.71429rem;
  border: 1px solid rgba(255, 255, 255, 0.04);
  border-radius: 0.71429rem;
  background: #10111a;
  box-sizing: border-box;
}

.custom-amount__main {
  display: flex;
  align-items: center;
  gap: 0.85714rem;
}

.recharge-custom .custom-amount__main {
  width: 100%;
  max-width: 40rem;
}

.recharge-custom .custom-amount__title {
  margin-bottom: 1.14286rem;
  color: #ffffff;
  font-size: ~"max(12PX, 1.14286rem)";
  font-weight: 800;
  line-height: 1.71429rem;
}

.recharge-custom .custom-amount__input-wrap {
  flex: 1;
  width: auto;
  height: 3.14286rem;
  padding: 0 1rem;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 0.42857rem;
  background: #15172a;
}

.recharge-custom .custom-amount__input {
  font-size: ~"max(12PX, 1rem)";
}

.recharge-custom .custom-amount__unit {
  font-size: ~"max(12PX, 1rem)";
  font-weight: 700;
}

.recharge-custom .custom-amount__row {
  margin-top: 0.71429rem;
  gap: 0;
}

.recharge-custom .custom-amount__tip {
  color: #6f778b;
  font-size: ~"max(12PX, 0.85714rem)";
  font-weight: 600;
}

.recharge-pay-section {
  margin-top: 1.57143rem;
  padding-top: 1.42857rem;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
}

.recharge-pay-section .pay-title {
  margin-bottom: 0.85714rem;
  color: #ffffff;
  font-size: ~"max(12PX, 1rem)";
  font-weight: 700;
}

.recharge-pay-methods {
  display: flex;
  gap: 0.85714rem;
}

.recharge-pay-item {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.57143rem;
  min-width: 9.42857rem;
  height: 2.85714rem;
  padding: 0 1.14286rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 0.42857rem;
  background: #11121b;
  cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease;

  &.selected {
    border-color: #7c3aed;
    background: rgba(124, 58, 237, 0.08);
    box-shadow: 0 0 0 1px rgba(124, 58, 237, 0.18);
  }

  .alipay-text,
  .wx-text {
    margin-left: 0;
    font-size: ~"max(12PX, 0.92857rem)";
    font-weight: 700;
  }
}

.recharge-footer {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
  height: 5.14286rem;
  padding: 0 2.85714rem;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  background: rgba(10, 11, 16, 0.96);
  box-sizing: border-box;
}

.recharge-footer__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
}

.recharge-footer__summary {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.recharge-footer__item {
  color: #6f778b;
  font-size: ~"max(12PX, 1rem)";
}

.recharge-footer__pay {
  min-width: 12rem;
  height: 3.14286rem;
  padding: 0 2rem;
  border: 0;
  border-radius: 0.57143rem;
  background: #8b5cf6;
  color: #ffffff;
  font-size: ~"max(12PX, 1.07143rem)";
  font-weight: 800;
  cursor: pointer;
  transition: background 0.18s ease, box-shadow 0.18s ease;

  &:hover:not(:disabled) {
    background: #9d6ff8;
    box-shadow: 0 0.28571rem 1.14286rem rgba(139, 92, 246, 0.35);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
}

@media (max-width: 1200px) {
  .recharge-cards {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 760px) {
  .recharge-wrap {
    padding: 2rem 1.14286rem 6.85714rem;
  }

  .recharge-cards {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .custom-amount__main {
    align-items: stretch;
    flex-direction: column;
  }

  .recharge-pay-methods {
    flex-direction: column;
  }

  .recharge-pay-item {
    width: 100%;
  }

  .recharge-footer {
    height: auto;
    padding: 1.14286rem;
  }

  .recharge-footer__inner {
    flex-direction: column;
    gap: 0.85714rem;
    height: auto;
  }

  .recharge-footer__summary {
    width: 100%;
    justify-content: space-between;
    gap: 0.85714rem;
  }

  .recharge-footer__pay {
    width: 100%;
  }
}
</style>

<style lang="less" scoped>
.score-card {
  width: 100%;
  border-radius: 0.71429rem;
  color: #e5e7eb;
}

/* 标题 */
.title {
  font-size: ~"max(12PX, 1.28571rem)";
  font-weight: 600;
  margin-bottom: 0.78571rem;
  border-bottom: 1px;
  padding-bottom: 0.78571rem;
  border-bottom: 1px dashed rgba(255, 255, 255, 0.08);
}

/* 行 */
.row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ~"max(12PX, 1.07143rem)";
  margin-bottom: 1rem;
  color: #94a3b8;
}

.main-score {
  margin-bottom: 1.42857rem;
}
.rowTitle {
  display: flex;
  font-size: ~"max(12PX, 1.07143rem)";
  margin-bottom: 1rem;
  color: #e5e7eb;
}
.icon {
  margin-right: 0.42857rem;
  width: 1rem;
  height: 1.21429rem;
}

.label {
  flex: 1;
  margin-left: 0.42857rem;
}

.value {
  font-weight: 500;
}

.blue {
  color: #a78bfa;
}

/* 按钮 */
.btn-box {
  text-align: center;
  margin-top: 0.71429rem;
  margin-bottom: 1.28571rem;
}

.charge-btn {
  width: 100%;
  padding: 0.71429rem 0;
  border: none;
  border-radius: 0.57143rem;
  background: linear-gradient(135deg, #a855f7, #6366f1);
  color: #fff;
  font-size: ~"max(12PX, 1.07143rem)";
  cursor: pointer;
  font-weight: 500;
  box-shadow: 0 0.28571rem 0.85714rem rgba(99, 102, 241, 0.3);
  transition: all 0.25s;
  &:hover {
    box-shadow: 0 0.42857rem 1.42857rem rgba(99, 102, 241, 0.5);
    transform: translateY(-1px);
  }
}

/* 下方跳转 */
.link {
  color: #a78bfa;
  font-size: ~"max(12PX, 1rem)";
  cursor: pointer;
}

.arrow {
  margin-left: 0.35714rem;
  font-weight: 600;
}
// 头像弹窗样式 start
.user-menu-panel {
  padding: 1.28571rem 1.42857rem 1rem;
  border-radius: 0.85714rem;
  background: #11121b;
  border: 1px solid rgba(51, 56, 78, 0.85);
  color: #f8fafc;
  box-shadow: 0 0.85714rem 2.85714rem rgba(0, 0, 0, 0.35);
}
.user-menu-panel__summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.85714rem;
  padding: 0 0.14286rem 0.14286rem;
}
.user-menu-panel__label {
  margin: 0;
  color: #8b93a7;
  font-size: ~"max(12PX, 0.92857rem)";
  line-height: 1.2;
  flex-shrink: 0;
}
.user-menu-panel__username {
  margin: 0;
  padding: 0.28571rem 0.71429rem;
  border-radius: 71.35714rem;
  background: rgba(124, 58, 237, 0.14);
  border: 1px solid rgba(167, 139, 250, 0.22);
  color: #e9d5ff;
  font-size: ~"max(12PX, 0.92857rem)";
  font-weight: 600;
  line-height: 1.2;
  text-align: right;
  max-width: 62%;
}
.user-menu-panel__divider {
  height: 1px;
  margin: 0 1.42857rem;
  background: rgba(255, 255, 255, 0.06);
}
.user-menu-panel__divider--footer-top {
  margin: 1rem 0 0;
}
.user-menu-panel__divider--logout-top {
  margin: 0.28571rem 1.42857rem 0;
}
.user-menu-panel__footer {
  margin: 0 -1.42857rem 0;
  display: flex;
  flex-direction: column;
}
.user-menu-panel__action {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.85714rem 1.42857rem;
  border: none;
  background: transparent;
  color: #fff;
  font-size: ~"max(12PX, 0.92857rem)";
  line-height: 1.2;
  cursor: pointer;
  font-family: inherit;
  transition: color 0.2s ease;
  &:hover {
    color: #a78bfa;
    .user-menu-panel__arrow {
      opacity: 1;
    }
    .user-menu-panel__action-left i {
      color: #a78bfa;
      background: rgba(167, 139, 250, 0.12);
    }
  }
}
.user-menu-panel__action-left {
  display: flex;
  align-items: center;
  gap: 0.71429rem;
  min-width: 0;
  i {
    flex-shrink: 0;
    width: 2rem;
    height: 2rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.57143rem;
    background: rgba(255, 255, 255, 0.04);
    font-size: ~"max(12PX, 0.92857rem)";
    color: #fff;
    transition: color 0.2s, background 0.2s;
  }
  > span {
    color: inherit;
  }
}
.user-menu-panel__arrow {
  font-size: ~"max(12PX, 0.85714rem)";
  opacity: 0.65;
  transition: opacity 0.2s;
}
.user-menu-panel__action--logout {
  margin-top: 0;
  padding-top: 0.85714rem;
  color: #f87171;
  .user-menu-panel__action-left i {
    color: #f87171;
    background: rgba(248, 113, 113, 0.1);
  }
  &:hover {
    color: #fca5a5;
    .user-menu-panel__action-left i {
      color: #fca5a5;
      background: rgba(248, 113, 113, 0.16);
    }
  }
}
.user-expirationTime {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ~"max(12PX, 0.92857rem)";
  > span:nth-child(2) {
    background: linear-gradient(135deg, #a855f7, #6366f1);
    border-radius: 0.42857rem;
    padding: 0.35714rem 0.71429rem;
    color: #fff;
    cursor: pointer;
    font-size: ~"max(12PX, 0.85714rem)";
    transition: all 0.2s;
    &:hover {
      box-shadow: 0 0.28571rem 0.85714rem rgba(99, 102, 241, 0.3);
    }
  }
}

.points-card {
  background: rgba(255, 255, 255, 0.04);
  border-radius: 0.85714rem;
  padding: 1.07143rem 1.07143rem;
  margin: 1.07143rem 0 0;
  border: 1px solid rgba(255, 255, 255, 0.06);
  > div:nth-child(2) {
    border-bottom: 1px dashed rgba(255, 255, 255, 0.08);
    margin-bottom: 1.07143rem;
  }
  .points-info {
    margin-bottom: 0.35714rem;
  }
  > div:last-child {
    margin-bottom: 0;
  }
}

.points-list {
  margin: 0 3.14286rem 1.07143rem;
  width: calc(100% - 6.28571rem);
}

.points-title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.85714rem;
  align-items: center;
  font-size: ~"max(12PX, 1rem)";
  > span:nth-child(1) {
    color: #e2e8f0;
    font-weight: bold;
  }
  > span:nth-child(2) {
    width: 4.14286rem;
    height: 1.57143rem;
    background: linear-gradient(135deg, #a855f7, #6366f1);
    box-shadow: 0 0.28571rem 0.85714rem rgba(99, 102, 241, 0.3);
    border-radius: 2.14286rem;
    color: #fff;
    text-align: center;
    line-height: 1.57143rem;
    font-size: ~"max(12PX, 0.85714rem)";
    cursor: pointer;
    transition: all 0.2s;
    &:hover {
      box-shadow: 0 0.42857rem 1.28571rem rgba(99, 102, 241, 0.45);
    }
  }
}

.points-info {
  display: flex;
  justify-content: space-between;
  font-size: ~"max(12PX, 1rem)";
  color: #64748b;
  > div:nth-child(1) {
    display: flex;
    align-items: center;
    > img {
      width: 1.14286rem;
      height: 1.14286rem;
      margin-left: 0.21429rem;
    }
  }
  > div:nth-child(2) {
    font-size: ~"max(12PX, 1rem)";
  }
}
.points-value {
  color: #a78bfa;
  font-weight: bold;
}
// 头像弹窗样式 end
</style>
<style lang="less" scoped>
/deep/ .el-menu--horizontal {
  border-bottom: none !important;
}
/deep/ .el-menu {
  background-color: #0d0e12;
}
/deep/ .el-menu-item.is-active {
  border-bottom: none !important;
  border-bottom-color: transparent !important;
}
/deep/ .el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
  border-bottom-color: transparent !important;
}

.head {
  width: 100%;
  height: 5.14286rem;
  background: #0d0e12;
  border-radius: 0 0 0 0;
  padding: 0 3.42857rem;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1499;
  // box-shadow: 0 0.14286rem 0.85714rem rgb(235 235 235);
}
.head--account-only {
  width: auto;
  height: auto;
  padding: 0;
  background: transparent;
  position: static;
  z-index: auto;
}
.head--account-only .pointsInformation {
  margin-right: 0;
}
.head--account-only .points {
  margin-right: 1.14286rem;
}
.headlogo {
  display: block;
  width: 10rem;
  object-fit: contain;
  // margin-right: 21.42857rem;
  //margin: 0 -3.64286rem 0 -6.42857rem;
}
.headlogo.is-clickable {
  cursor: pointer;
}
.tablabel {
  font-weight: 500;
  font-size: ~"max(12PX, 1.14286rem)";
  // line-height: 1.42857rem;
  text-align: left;
  // margin-right: 4.64286rem;
  // padding: 0 1.42857rem;
  cursor: pointer;
	height: auto !important;
	line-height: normal !important;
  > span {
    margin-left: 0.28571rem;
  }
  img {
    max-width: 1.42857rem;
  }
}
.header-unread-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.1rem;
  height: 1.1rem;
  margin-left: 0.35rem;
  padding: 0 0.25rem;
  border-radius: 0.7rem;
  background: #f04444;
  color: #fff;
  font-size: 0.72rem;
  line-height: 1;
  vertical-align: middle;
}
/deep/ .el-menu--horizontal > .el-menu-item.tablabel {
  padding: 0 0.85714rem;
}
/deep/ .el-menu--horizontal
  > .el-submenu.help-menu
  > .el-submenu__title
  .el-submenu__icon-arrow {
  width: auto;
  margin: 0 0 0 8px;
}
/deep/ .el-menu--horizontal>.el-submenu .el-submenu__title{
	height: auto !important;
	line-height: normal !important;
}
.nav-menu-icon {
  margin-right: 0.28571rem;
  color: inherit;
  font-size: ~"max(12PX, 1.28571rem)";
}
.activate {
  color: #a78bfa;
}
.pointsInformation {
  height: 2.28571rem;
  margin-right: 1.71429rem;
  gap: 0.85714rem;
}
.head:not(.head--account-only) .pointsInformation {
  position: absolute;
  top: 50%;
  right: 3.42857rem;
  transform: translateY(-50%);
  margin-right: 0;
}
.header-language-switch {
  box-sizing: border-box;
  display: inline-flex;
  flex: 0 0 auto;
  width: 6.57143rem;
  height: 2.28571rem;
  padding: 0.21429rem;
  border: 1px solid rgba(255, 255, 255, 0.24);
  border-radius: 0.42857rem;
  background: rgba(255, 255, 255, 0.06);

  button {
    flex: 1 1 0;
    min-width: 0;
    padding: 0;
    border: 0;
    border-radius: 0.28571rem;
    background: transparent;
    color: rgba(255, 255, 255, 0.68);
    font-size: ~"max(12PX, 0.85714rem)";
    line-height: 1.71429rem;
    white-space: nowrap;
    cursor: pointer;
    transition: background-color 0.18s ease, color 0.18s ease;

    &:hover,
    &:focus-visible {
      color: #ffffff;
      outline: none;
    }

    &:focus-visible {
      box-shadow: inset 0 0 0 1px #a78bfa;
    }

    &.active {
      background: #6f42ff;
      color: #ffffff;
    }
  }
}
.subscription-trigger {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2.28571rem;
  padding: 0 1.14286rem;
  margin-right: 0;
  border-radius: 71.35714rem;
  background: linear-gradient(
    135deg,
    rgba(124, 58, 237, 0.15),
    rgba(240, 185, 11, 0.1)
  );
  border: 1px solid rgba(240, 185, 11, 0.3);
  color: #ffffff;
  font-size: ~"max(11PX, 0.85714rem)";
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  outline: none;
  cursor: pointer;
  transition: border-color 0.18s ease;
}
.subscription-trigger:hover,
.subscription-trigger:focus-visible {
  border-color: #ffffff;
}
.points {
  width: 12rem;
  height: 2.28571rem;
  background: linear-gradient(135deg, #a855f7, #6366f1);
  box-shadow: 0 0.28571rem 0.85714rem rgba(99, 102, 241, 0.3);
  border-radius: 2.14286rem;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-right: 3.28571rem;
  cursor: pointer;
  transition: all 0.2s;
  &:hover {
    box-shadow: 0 0.42857rem 1.42857rem rgba(99, 102, 241, 0.5);
  }
}
.avatar {
  box-sizing: border-box;
  width: 2.28571rem;
  height: 2.28571rem;
  border-radius: 50%;
  background: linear-gradient(135deg, #7c3aed, #a78bfa);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: ~"max(12PX, 0.92857rem)";
  color: #fff;
  font-weight: 600;
  border: 0.14286rem solid #1e1e35;
  margin-left: 0;
  cursor: pointer;
}
.avatar-text {
  font-size: ~"max(12PX, 1.07143rem)";
  color: #fff;
  font-weight: 600;
  line-height: 1;
}
</style>
